import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Box,
    Button,
    Card,
    Checkbox,
    Chip,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    IconButton,
    InputBase,
    InputLabel,
    List,
    ListItem,
    ListItemIcon,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    TextField,
    CardContent,
    Typography,
    ListItemText,
} from '@mui/material';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import axiosInstance from 'custom-axios';
// import { Controller, useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { checkboxColorSx, countryList, currencyArray, externalInvestmentOptions, getAccountOptionLabel, getAddressTypeArrayLabel, getAmlQiVerificationLabel, getContributionTypeLabel, getCountryLabel, getCurrencyLabel, getEmploymentLabel, getGenderLabel, getHolderMaterials, getInstitutionTransferTypeLabel, getLanguageLabel, getMaritalLabel, getOriginOfContactLabel, getPacFrequencyLabel, getProvinceLabel, getRegistrationTypeLabel, getRelationsLabel, getRole, getRoleLabels, getTitleLabel, getYesNoLabel, initialInvestmentArray, institutionTransferType, provinceList, radioColorSx, radioOptionArray, relationArray, useOfAccountArray } from 'store/constant';
import NumberFormat from 'react-number-format';
import { numberFormat } from 'hooks/useNumberFormat';
import DiscardModal from './DiscardModal';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
// import CloudDownload from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import { faDownload, faFileAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import DownloadIcon from "@mui/icons-material/Download";
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';
import DonutChart from 'views/charts/DonutChart';
import CheckIcon from '@mui/icons-material/Check';
import { formatDateDMY } from '../../../../../styles/commonFunction';
import ApprovalModal from './ApprovalModal';

// import { Controller } from 'react-hook-form';


const stepOfReview = ['HouseHold', 'Accounts', 'Questionnaire'];


const contentTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
};


const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
};

const Review = ({ setActiveChildStep, activeChildStep, setActiveParentStep, activeParentStep }) => {

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [houseHoldData, setHouseHoldData] = useState([])
    const [regulatoryFiles, setRegulatoryFiles] = useState([])
    // const [accountData, setFormAccountData] = useState([])
    const [accountsData, setAccountsData] = useState([])
    const [questionnaireData, setQuestionnaireData] = useState([])
    const [questionnairePortfolioData, setQuestionnairePortfolioData] = useState([])
    const [clientGroupData, setClientGroupData] = useState([])
    const [userDeclineData, setUserDeclineData] = useState([])
    const [permissionData, setPermissionData] = useState([])
    const [managerPermissionData, setManagerPermissionData] = useState({})
    const [roleData, setRoleData] = useState({ role_id: 0 })

    const [loadData, setLoadData] = useState(false)
    const [adminReviewApproved, setAdminReviewApproved] = useState(false);
    // const [pmReviewStatus, setPmReviewStatus] = useState(permissionData['pm_approved']);
    const [openFrom, setOpenFrom] = useState('');

    const [open, setOpen] = React.useState(false);
    // const [chartData, setChartData] = useState([])

    // approve button modal state
    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [approveMeta, setApproveMeta] = useState({ role: '', action: '' });


    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id')
    const userId = id ? id : userGetId;
    let loginId = localStorage.getItem('login_id')

    const loginType = localStorage.getItem('login_type');

    const isSuperAdmin = roleData?.role_id === 4;
    const isAdminLogin = loginType === 'admin';
    const isPmLogin = loginType === 'portfolio_manager_admin';
    const isHoArRole = roleData?.role_id === 1;


    const handleClickOpen = (openFrom) => {
        setOpenFrom(openFrom);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenFrom('');
    };

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 2, child_step: 0 }

        try {
            showLoader()

            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(activeParentStep - 1)
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
        hideLoader()
    };

    const handleNextStep = async () => {
        const endPoint = `api/change-form-step`;
        const submitData = { user_id: userId ? userId : 0, parent_step: activeParentStep + 1, child_step: 0 };
        try {
            showLoader()
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveParentStep(activeParentStep + 1);
            }

        } catch (error) {
            // console.error(error);
            toast.error('An error occurred when navigating back.');
        }
        hideLoader()
    }

    const handleApprove = async (role, action) => {

        setApproveMeta({ role, action });
        setOpenApproveModal(true);

        /* const result = await showConfirmSweetAlert({
            title: `${action.charAt(0).toUpperCase() + action.slice(1)} Application?`,
            text: `Are you sure you want to ${action} this application?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Yes, ${action} it!`,
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            setApproveMeta({ role, action });
            setOpenApproveModal(true);
        } */
    };

    const processApproval = async (role, action, notes) => {
        try {
            showLoader();

            let updatedPermissions;

            if (role === 'admin') {

                const adminData = { user_id: userId, login_id: loginId, role: role, action: action }

                const response = await axiosInstance.post('/api/admin/change-manager-permission', adminData);

                if (response.success) {

                    const approveResponse = await axiosInstance.post('/api/user-application-approve', {
                        user_id: userId,
                        declined_by: loginId,
                        decline: 1,
                        reason: notes
                    });

                    if (approveResponse.success) {

                        updatedPermissions = {
                            ...permissionData,
                            'admin_reviewed': action === 'approve' ? 1 : 0
                        };

                        setPermissionData(updatedPermissions);
                        setAdminReviewApproved(action === 'approve');
                        toast.success(`Successfully ${action} the application`);
                    } else {
                        toast.error('Failed to update application status. Please try again.');
                    }
                }

            } else if (role === 'pm') {

                const adminData = { user_id: userId, login_id: loginId, role: role, action: action }

                const response = await axiosInstance.post('/api/admin/change-manager-permission', adminData);


                if (response.success) {

                    const approveResponse = await axiosInstance.post('/api/user-application-approve', {
                        user_id: userId,
                        declined_by: loginId,
                        decline: 2,
                        reason: notes
                    });

                    if (approveResponse.success) {

                        updatedPermissions = {
                            ...permissionData,
                            'pm_approved': action === 'approve' ? 1 : 0
                        };


                        setPermissionData(updatedPermissions);
                        toast.success(`Successfully ${action} the application`);
                    } else {
                        toast.error('Failed to update application status. Please try again.');
                    }
                }
            }

            hideLoader();
            setOpenApproveModal(false);

        } catch (error) {
            hideLoader();
        }
    };



    const fetchUserAllPersonal = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-all-info/${userId}`);

            setHouseHoldData(response.personal_data)
            // fetchRegulatoryFiles()

        } catch (error) {
            // console.error(error.message);
        }
    };


    const fetchRolePermission = async () => {
        try {
            // const response = await axiosInstance.get(`api/manager-permissions/${loginId}`);
            const response = await axiosInstance.get(`api/user-application-status/${userId}`);

            if (response.data) {
                setPermissionData(response.data)
                setOpenFrom(response.data.is_declined)
            }

        } catch (error) {
            // console.error(error.message);
        }
    };

    const fetchManagerPermission = async () => {
        try {
            const response = await axiosInstance.get(`api/manager-permissions/${loginId}`);

            if (response.status == 200) {
                setManagerPermissionData(response.permissions)
                setRoleData({ role_id: response.role_id })
            }

        } catch (error) {
            // console.error(error.message);
        }
    };


    const fetchAccountData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-info/${userId}`);

            if (response.status == 200) {
                setAccountsData(response.data)
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const adminReviewPermission = managerPermissionData['ADMIN REVIEW'] == 1;
    const pmReviewPermission = managerPermissionData['PM REVIEW'] == 1 || managerPermissionData['PM REVIEW'] == 2;

    const adminReviewed = Number(permissionData?.admin_reviewed) === 1;
    const pmApproved = Number(permissionData?.pm_approved) === 1;
    const isDeclined = Number(permissionData?.is_declined) === 1;

    // Admin approve
    const isAdminApprover =
        (isSuperAdmin || isAdminLogin) &&
        adminReviewPermission &&
        permissionData?.admin_reviewed !== 1;

    // PM approve
    const isPmApprover =
        (
            (isHoArRole && isPmLogin) ||
            isSuperAdmin
        ) &&
        adminReviewed &&
        !pmApproved &&
        !isDeclined;


    const isPmDecline =
        (
            isPmLogin ||
            isSuperAdmin
        ) &&
        adminReviewed &&
        !pmApproved &&
        !isDeclined;

    const isNextButtonEnabled = () => {

        if ((loginType === 'client' && permissionData) && (permissionData.admin_reviewed == 1 && (permissionData.pm_approved == 1 || permissionData.pm_approved == 2))) {
            return true;
        }
        return false;
    };

    const isDeclineButtonEnabled = () => {
        if ((adminReviewPermission || pmReviewPermission) && (permissionData && permissionData.admin_reviewed == 1 && (permissionData.pm_approved == 1 || permissionData.pm_approved == 2))) {
            return true;
        }
        return false;
    };

    const OpenDiscardModal = () => {
        return (
            <>
                <DiscardModal fetchRolePermission={fetchRolePermission} setOpenFrom={setOpenFrom} openFrom={openFrom} handleClose={handleClose} open={open} userId={userId} loginId={loginId} />
            </>
        )
    }

    const fetchUserInfo = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-form-info/${userId}`);

            setClientGroupData(response.client_group_details);
            setRegulatoryFiles(response.regulatory_files_details)
            setQuestionnaireData(response.risk_questionnaire_details)
            setQuestionnairePortfolioData(response.questionnaire_portfolio_details)
            setUserDeclineData(response.user_decline_details)

        } catch (error) {
            // console.error(error.message)
        }
    }

    const fetchAllApi = async () => {

        try {
            showLoader()
            await fetchUserInfo()
            await fetchRolePermission()
            await fetchManagerPermission()
            await fetchUserAllPersonal()
            // await fetchAccountTypeData()
            await fetchAccountData()
            // await fetchClientGroupAccountData()
            // await fetchRegulatoryFiles()
            hideLoader()
            setLoadData(true)

        } catch (error) {
            // console.error(error)
        }
    }

    useEffect(() => {
        fetchAllApi()
    }, [])

    useEffect(() => {
        if (permissionData.admin_reviewed == 1) {
            setAdminReviewApproved(true);
        }
    }, [permissionData]);


    return (
        <>
            <div className='padding-left35px padding-right35px bg-white'>
                {permissionData.is_declined !== 1 ? (
                    <Box
                        sx={{
                            border: '1px solid #ced4da',
                            padding: '10px',
                            marginBottom: '10px',
                            backgroundColor: '#f0f4f7',
                            borderRadius: '8px'
                        }}
                    >
                        <Box
                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}
                        >
                            <Typography variant="h6" component="div" gutterBottom sx={{ fontSize: '16px' }}>
                                Your Application is being reviewed by the Admin/PM:
                            </Typography>
                        </Box>

                        <Typography variant="body1" component="div" sx={{
                            fontSize: "14px",
                            pb: "5px",
                            color: "#000"
                        }}>
                            <strong>Status:</strong>
                        </Typography>


                        {/* ----------------------- ADMIN APPROVAL -------------------- */}

                        <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }}>

                            <Typography variant="body1" component="div" sx={{
                                fontSize: "14px",
                                color: "#000",
                                width: "180px"
                            }}>
                                {/* Admin Review: {permissionData.admin_reviewed == 1 ? 'Approved' : 'Pending'} */}

                                Admin Review: {permissionData.admin_reviewed === 1 ? (
                                    <Chip
                                        label="Approved"
                                        sx={{ backgroundColor: '#33cb67', height: '22px', color: '#fff' }}
                                    />
                                ) : (
                                    <Chip
                                        label="Pending"
                                        sx={{ backgroundColor: '#DCC574', height: '22px', color: '#fff' }}
                                    />
                                )}
                            </Typography>

                            {/* only Admin and Super Admin only can approve */}
                            {isAdminApprover && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    sx={{ marginLeft: '10px', fontSize: '12px', padding: '2px 8px' }}
                                    onClick={() => handleApprove('admin', 'approve')}
                                >
                                    Approve
                                </Button>
                            )}

                        </Box>

                        {/* ----------------------- PM APPROVAL -------------------- */}
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }}>

                            <Typography variant="body1" component="div" sx={{
                                fontSize: "14px",
                                color: "#000",
                                width: "180px"
                            }}>
                                PM Approval: {permissionData.pm_approved == 1 ?
                                    (
                                        <Chip
                                            label="Approved"
                                            sx={{ backgroundColor: '#33cb67', height: '22px', color: '#fff' }}
                                        />
                                    ) : (
                                        <Chip
                                            label="Pending"
                                            sx={{ backgroundColor: '#DCC574', height: '22px', color: '#fff' }}
                                        />
                                    )}
                            </Typography>


                            {isPmApprover && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    sx={{ marginLeft: '10px', fontSize: '12px', padding: '2px 8px' }}
                                    onClick={() => handleApprove('pm', 'approve')}
                                    disabled={!permissionData?.admin_reviewed}
                                >
                                    Approve
                                </Button>
                            )}

                            {isPmDecline &&
                                (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        sx={{ fontSize: '12px', padding: '2px 8px', ml: 2 }}
                                        onClick={() => handleClickOpen(1)}
                                        disabled={isDeclineButtonEnabled()}
                                    >
                                        Not Approve
                                    </Button>
                                )}
                        </Box>

                        {userDeclineData?.length > 0 && (
                            <Card variant="outlined" sx={{ mt: 2, backgroundColor: "#fff5f5" }}>
                                <CardContent>
                                    <Typography variant="subtitle1" fontWeight="bold" color="error">
                                        Reasons for Not Approval
                                    </Typography>

                                    <List dense>
                                        {userDeclineData.map((item, index) => (
                                            <div key={item.id}>
                                                <ListItem alignItems="flex-start">
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: "0.9em",

                                                        }}
                                                    >
                                                        <FiberManualRecordIcon
                                                            sx={{
                                                                fontSize: "0.45em",
                                                                mt: "5px",
                                                                color: "text.secondary",
                                                            }}
                                                        />
                                                    </ListItemIcon>

                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                                                                {item.reason}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Typography variant="caption" color="text.secondary">
                                                                {formatDateDMY(item?.created_at)}
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItem>

                                                {index !== userDeclineData.length - 1 && <Divider sx={{ backgroundColor: '#e8e8e8' }} />}
                                            </div>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        )}

                        <Typography variant="body2" component="div" sx={{ marginTop: '10px', fontSize: '15px' }}>
                            Once all above status is completed you are eligible to move on to the final steps which involve signing an agreement.
                        </Typography>
                    </Box>

                ) : (
                    <Box sx={{
                        border: '2px solid #f5c6cb',
                        padding: '10px',
                        marginBottom: '20px',
                        backgroundColor: '#f8d7da',
                        borderRadius: '8px'
                    }}>

                        <Typography variant="body1" component="div"
                            sx={{
                                fontSize: "14px",
                                color: "#721c24",

                            }}>
                            Your Application is declined by the PM. Please contact your advisor for more details.
                        </Typography>

                        {loginType !== 'client' && adminReviewPermission &&
                            (<Button
                                variant="outlined"
                                color="error"
                                size="small"
                                sx={{ marginTop: '20px', fontSize: '12px', padding: '2px 8px' }}
                                onClick={() => handleClickOpen(0)}
                            >
                                Accept
                            </Button>)
                        }
                    </Box>
                )}

                {stepOfReview.map((account, index) => (
                    <Box mb={2} key={index}>
                        <Accordion>
                            <AccordionSummary
                                // expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                sx={{ padding: 0 }}
                            >
                                <Alert
                                    severity="info"
                                    icon={false}  // Remove the default start icon in Alert
                                    sx={{
                                        width: '100%',
                                        display: 'flow'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                        <Typography variant="body1" className='font15px'>{account}</Typography>
                                        <IconButton
                                            aria-label="expand"
                                            size="small"
                                            sx={{ color: 'inherit', p: 0.5 }}
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    </Box>
                                </Alert>
                            </AccordionSummary>

                            <AccordionDetails className='padding0px'>
                                {(index === 0 && loadData) && HouseHoldComponent(loadData, houseHoldData, regulatoryFiles, setRegulatoryFiles, userId, clientGroupData)}
                                {(index === 1 && loadData) && AccountComponent(loadData, accountsData, setAccountsData, userId)}
                                {(index === 2 && loadData) && questionnaireComponent(loadData, questionnaireData, questionnairePortfolioData)}
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                ))}

                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleNextStep} disabled={!isNextButtonEnabled()}>
                        Next
                    </Button>
                </Grid>
            </div>
            <OpenDiscardModal />

            {/* approval modal */}
            <ApprovalModal
                open={openApproveModal}
                onClose={() => setOpenApproveModal(false)}
                action={approveMeta.action}
                onSubmit={(notes) =>
                    processApproval(approveMeta.role, approveMeta.action, notes)
                }
            />

            {loader}
            <ToastContainer />
        </>
    )
}

export default Review;


const HouseHoldComponent = (loadData, hData, regulatoryFiles, setRegulatoryFiles, userId, cData) => {

    let clientFullName = loadData && hData.p_first_name + ' ' + hData.p_last_name

    const siiArray = typeof cData?.source_initial_investment === 'string'
        ? cData?.source_initial_investment.split(',').map(Number)
        : Array.isArray(cData?.source_initial_investment)
            ? cData?.source_initial_investment.map(Number)
            : [];



    const downloadRegulatoryFile = async (_name, id) => {

        try {
            const response = await axiosInstance.get(`api/download-regulatory-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });

            const contentType = response['type'];

            if (contentType && contentType.includes('application/json')) {

                // Handle error response
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'An error occurred.');
                };
                reader.readAsText(response.data);
            } else {

                // Determine file extension and MIME type
                const extension = getFileExtension(_name);
                const mimeType = contentTypes[extension] || 'application/octet-stream';

                const url = window.URL.createObjectURL(new Blob([response], { type: mimeType }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);
        }
    }

    const deleteRegulatoryFile = async (fileName, id, fileIndex) => {

        try {
            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: `You will not be able to recover this!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                const data = { file_name: fileName, user_id: userId, id: id }

                const response = await axiosInstance.post(`api/delete-regulatory-file`, data);

                if (response.success) {

                    // const updatedFiles = [...regulatoryFiles];
                    // updatedFiles.splice(fileIndex, 1);
                    // setRegulatoryFiles(updatedFiles);

                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            }

        } catch (error) {
            // toast.error(error.message)
            // console.error(error)
        }
    }

    return (
        <>
            {loadData &&
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={12}>

                        <>
                            {/* -------------------PERSONAL INFORMATION -------------------- */}
                            <Paper elevation={3} className='review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Personal Information
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Household Name: </span>
                                                <span className="bold-text">{hData.household_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Household Preferred Languages: </span>
                                                <span className="bold-text">{getLanguageLabel(hData.household_language)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">RR Code: </span>
                                                <span className="bold-text">{hData.rr_code}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Role Type: </span>
                                                <span className="bold-text">{getRole(hData.role_type)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Role: </span>
                                                <span className="bold-text">{getRoleLabels(hData.role_options)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Registration Type: </span>
                                                <span className="bold-text">{getRegistrationTypeLabel(hData.registration_type)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Title: </span>
                                                <span className="bold-text">{getTitleLabel(hData.p_title)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">First Name: </span>
                                                <span className="bold-text">{hData.p_first_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Middle Name: </span>
                                                <span className="bold-text">{hData.p_middle_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Last Name: </span>
                                                <span className="bold-text">{hData.p_last_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Email: </span>
                                                <span className="bold-text">{hData.p_email}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Date of Birth: </span>
                                                <span className="bold-text">{hData.p_dob}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">SIN: </span>
                                                <span className="bold-text">{hData.p_sin}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Marital Status: </span>
                                                <span className="bold-text">{getMaritalLabel(hData.p_marital_status)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">No of Dependents: </span>
                                                <span className="bold-text">{hData.p_no_of_dependent}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Country: </span>
                                                <span className="bold-text">{getCountryLabel(hData.p_citizenship)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Gender: </span>
                                                <span className="bold-text">{getGenderLabel(hData.p_gender)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Home Phone: </span>
                                                <span className="bold-text">{hData.p_home_phone}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Cell Phone: </span>
                                                <span className="bold-text">{hData.p_cell_phone}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Business Phone: </span>
                                                <span className="bold-text">{hData.p_business_phone}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Extension: </span>
                                                <span className="bold-text">{hData.p_extension}</span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Employment Status: </span>
                                                <span className="bold-text">{getEmploymentLabel(hData.p_employment_status)}</span>
                                            </Typography>
                                        </Grid>


                                        {hData.p_employment_status == 1 && (
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Job Title: </span>
                                                        <span className="bold-text">{hData.p_emp_job_title}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Emp. Name: </span>
                                                        <span className="bold-text">{hData.p_emp_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Type Of Business: </span>
                                                        <span className="bold-text">{hData.p_emp_business}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Years of employment: </span>
                                                        <span className="bold-text">{hData.p_emp_years_employment}</span>
                                                    </Typography>
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </Box>
                            </Paper>

                            {/* -------------------SPOUSAL INFORMATION -------------------- */}
                            {hData.p_marital_status == 2 || hData.p_marital_status == 3 ? (
                                <>
                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Spousal Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">First Name: </span>
                                                        <span className="bold-text">{hData.s_first_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Middle Name: </span>
                                                        <span className="bold-text">{hData.s_middle_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Last Name: </span>
                                                        <span className="bold-text">{hData.s_last_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Email: </span>
                                                        <span className="bold-text">{hData.s_email}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Date of Birth: </span>
                                                        <span className="bold-text">{hData.s_dob}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Marital Status: </span>
                                                        <span className="bold-text">{getMaritalLabel(hData.p_marital_status === 2 ? 2 : hData.s_marital_status)}</span>
                                                    </Typography>
                                                </Grid>

                                                {/* <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">No of Dependents: </span>
                                                        <span className="bold-text">{hData.s_no_of_dependent}</span>
                                                    </Typography>
                                                </Grid> */}

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{(hData.s_citizenship)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Gender: </span>
                                                        <span className="bold-text">{getGenderLabel(hData.s_gender)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Home Phone: </span>
                                                        <span className="bold-text">{hData.s_home_phone}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Cell Phone: </span>
                                                        <span className="bold-text">{hData.s_cell_phone}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Business Phone: </span>
                                                        <span className="bold-text">{hData.s_business_phone}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Extension: </span>
                                                        <span className="bold-text">{hData.s_extension}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Employment Status: </span>
                                                        <span className="bold-text">{getEmploymentLabel(hData.s_employment_status)}</span>
                                                    </Typography>
                                                </Grid>

                                                {hData.s_employment_status == 1 && (
                                                    <>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Job Title: </span>
                                                                <span className="bold-text">{hData.s_emp_job_title}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Emp. Name: </span>
                                                                <span className="bold-text">{hData.s_emp_name}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Type Of Business: </span>
                                                                <span className="bold-text">{hData.s_emp_business}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Years of employment: </span>
                                                                <span className="bold-text">{hData.s_emp_years_employment}</span>
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Paper>
                                </>
                            ) : null}


                            {/* -------------------JOINT INFORMATION -------------------- */}
                            <Paper elevation={3} className='mt-3 review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Joint Information
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        {hData.registration_type == 2 || hData.registration_type == 4 ? (
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Title: </span>
                                                        <span className="bold-text">{getTitleLabel(hData.jt_title)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Marital Status: </span>
                                                        <span className="bold-text">{getMaritalLabel(hData.jt_marital_status)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">First Name: </span>
                                                        <span className="bold-text">{hData.jt_first_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Middle Name: </span>
                                                        <span className="bold-text">{hData.jt_middle_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Last Name: </span>
                                                        <span className="bold-text">{hData.jt_last_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">SIN: </span>
                                                        <span className="bold-text">{hData.jt_sin}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Date of Birth: </span>
                                                        <span className="bold-text">{hData.jt_dob}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Email: </span>
                                                        <span className="bold-text">{hData.jt_email}</span>
                                                    </Typography>
                                                </Grid>


                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Home Phone: </span>
                                                        <span className="bold-text">{hData.jt_home_phone}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Cell Phone: </span>
                                                        <span className="bold-text">{hData.jt_cell_phone}</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Business Phone: </span>
                                                        <span className="bold-text">{hData.jt_business_phone}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Extension: </span>
                                                        <span className="bold-text">{hData.jt_extension}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">No of Dependents: </span>
                                                        <span className="bold-text">{hData.jt_no_of_dependent}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{getCountryLabel(hData.jt_citizenship)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Address Type: </span>
                                                        <span className="bold-text">{getAddressTypeArrayLabel(hData.jt_address_type)}</span>
                                                    </Typography>
                                                </Grid>


                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">RR No: </span>
                                                        <span className="bold-text">{hData.jt_rr_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Street No: </span>
                                                        <span className="bold-text">{hData.jt_street_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Street Name: </span>
                                                        <span className="bold-text">{hData.jt_street_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Street Type: </span>
                                                        <span className="bold-text">{hData.jt_street_type}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Unit/Apt No: </span>
                                                        <span className="bold-text">{hData.jt_unit_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Unit/Apt No: </span>
                                                        <span className="bold-text">{hData.jt_unit_type}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> City: </span>
                                                        <span className="bold-text">{hData.jt_city}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Province: </span>
                                                        <span className="bold-text">{getProvinceLabel(hData.jt_province)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{getCountryLabel(hData.jt_province)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Postal Code: </span>
                                                        <span className="bold-text">{(hData.jt_postal_code)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Name Of Employer: </span>
                                                        <span className="bold-text">{(hData.jt_emp_name)}</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Type of Business: </span>
                                                        <span className="bold-text">{(hData.jt_emp_business)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Occupation: </span>
                                                        <span className="bold-text">{(hData.jt_occupation)}</span>
                                                    </Typography>
                                                </Grid>

                                                {hData.jt_marital_status == 2 || hData.jt_marital_status == 3 ? (
                                                    <>
                                                        <Grid item xs={12} sm={12}>
                                                            <Typography component="h2" variant="h4" gutterBottom
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                    color: "#3f51b5"
                                                                }}
                                                                className='text-capitalize'>
                                                                Spousal Information
                                                            </Typography>
                                                            <Divider />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">First Name: </span>
                                                                <span className="bold-text">{hData.jt_s_first_name}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Middle Name: </span>
                                                                <span className="bold-text">{hData.jt_s_middle_name}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Last Name: </span>
                                                                <span className="bold-text">{hData.jt_s_last_name}</span>
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Name Of Employer: </span>
                                                                <span className="bold-text">{(hData.jt_s_emp_name)}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Type of Business: </span>
                                                                <span className="bold-text">{(hData.jt_s_emp_business)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Occupation: </span>
                                                                <span className="bold-text">{(hData.jt_s_occupation)}</span>
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                ) : null}
                                            </>

                                        ) :
                                            <Grid item xs={12}>
                                                <Typography component="h2" variant="h4" gutterBottom
                                                    sx={{
                                                        fontSize: "13px",
                                                        color: "#000"
                                                    }}
                                                    className='text-capitalize text-center'>
                                                    No record found
                                                </Typography>
                                            </Grid>
                                        }
                                    </Grid>
                                </Box>
                            </Paper>

                            {/* ------------------ ADDRESS INFORMATION  ----------------------*/}
                            <Paper elevation={3} className='mt-3 review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Address
                                            </Typography>
                                            <Divider />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Address Type: </span>
                                                <span className="bold-text">{getAddressTypeArrayLabel(hData.l_address_type)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Civic/RR No: </span>
                                                <span className="bold-text">{hData.l_rr_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Unit No: </span>
                                                <span className="bold-text">{hData.l_unit_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Unit type: </span>
                                                <span className="bold-text">{hData.l_unit_type}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street No: </span>
                                                <span className="bold-text">{hData.l_street_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street Name: </span>
                                                <span className="bold-text">{hData.l_street_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street Type: </span>
                                                <span className="bold-text">{hData.l_street_type}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">City: </span>
                                                <span className="bold-text">{hData.l_city}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Country: </span>
                                                <span className="bold-text">{getCountryLabel(hData.l_country)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Province: </span>
                                                <span className="bold-text">{getProvinceLabel(hData.l_province)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Postal Code: </span>
                                                <span className="bold-text">{hData.l_postal_code}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder font14px">
                                                <span className="light-text">Is mailing address different than the legal address? If Yes, use same as above: </span>
                                                <span className="bold-text">{getYesNoLabel(hData.same_mailing_address)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Mailing Address
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Address Type: </span>
                                                <span className="bold-text">{getAddressTypeArrayLabel(hData.m_address_type)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Civic/RR No: </span>
                                                <span className="bold-text">{hData.m_rr_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Unit No: </span>
                                                <span className="bold-text">{hData.m_unit_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Unit type: </span>
                                                <span className="bold-text">{hData.m_unit_type}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street No: </span>
                                                <span className="bold-text">{hData.m_street_no}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street Name: </span>
                                                <span className="bold-text">{hData.m_street_name}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Street Type: </span>
                                                <span className="bold-text">{hData.m_street_type}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">City: </span>
                                                <span className="bold-text">{hData.m_city}</span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Country: </span>
                                                <span className="bold-text">{getCountryLabel(hData.m_country)}</span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Province: </span>
                                                <span className="bold-text">{getProvinceLabel(hData.m_province)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Postal Code: </span>
                                                <span className="bold-text">{hData.m_postal_code}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder font14px">
                                                <span className="light-text">Is there a third-party address: </span>
                                                <span className="bold-text">{getYesNoLabel(hData.third_party_address)}</span>
                                            </Typography>
                                        </Grid>

                                        {hData.third_party_address == 1 ?
                                            <>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Third Party Address
                                                    </Typography>
                                                    <Divider />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Address Type: </span>
                                                        <span className="bold-text">{getAddressTypeArrayLabel(hData.tp_address_type)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Civic/RR No: </span>
                                                        <span className="bold-text">{hData.tp_rr_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Unit No: </span>
                                                        <span className="bold-text">{hData.tp_unit_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Unit type: </span>
                                                        <span className="bold-text">{hData.tp_unit_type}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Street No: </span>
                                                        <span className="bold-text">{hData.tp_street_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Street Name: </span>
                                                        <span className="bold-text">{hData.tp_street_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Street Type: </span>
                                                        <span className="bold-text">{hData.tp_street_type}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">City: </span>
                                                        <span className="bold-text">{hData.tp_city}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{getCountryLabel(hData.tp_country)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Province: </span>
                                                        <span className="bold-text">{getProvinceLabel(hData.tp_province)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Postal Code: </span>
                                                        <span className="bold-text">{(hData.tp_postal_code)}</span>
                                                    </Typography>
                                                </Grid>
                                            </>
                                            : null}
                                    </Grid>
                                </Box>
                            </Paper>

                            {/* ------------------ FINANCIAL INFORMATION------------------------ */}
                            <Paper elevation={3} className='mt-3 review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Financial Information
                                            </Typography>
                                            <Divider />
                                        </Grid>


                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Estimated Net Liquid Assets: </span>
                                                <span className="bold-text">{numberFormat(hData.enl_assets)}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Account holders annual income from all sources: </span>
                                                <span className="bold-text">{numberFormat(hData.annual_income)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Estimated Net Fixed Assets: </span>
                                                <span className="bold-text">{numberFormat(hData.enf_assets)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">{hData?.s_first_name || 'Spouse'}'s  account holders annual income from all sources (Value must be expressed in CAD): </span>
                                                <span className="bold-text">{numberFormat(hData.s_annual_income)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Estimated Total Net Worth: </span>
                                                <span className="bold-text">{numberFormat(hData.total_net_worth)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={4} className='text-left'> <label className='font15px font-weight500px'>Asset Category</label></Grid>
                                        <Grid item xs={4}> <label className='font15px font-weight500px'>Non-Registered</label></Grid>
                                        <Grid item xs={4}> <label className='font15px font-weight500px'>Registered</label></Grid>

                                        {externalInvestmentOptions.map(option => (

                                            <React.Fragment key={option.label}>

                                                <Grid item xs={4} className='text-left align-content-center'>
                                                    <label className='font15px'>{option.label}</label>
                                                </Grid>

                                                {option.fields.map(field => (
                                                    <Grid item xs={4} key={field}>
                                                        <NumberFormat
                                                            customInput={TextField}
                                                            prefix={'$'}
                                                            allowNegative={false}
                                                            name={field}
                                                            value={hData[field]}
                                                            variant="outlined"
                                                            thousandSeparator={true}
                                                            size='small'
                                                            fullWidth
                                                            disabled
                                                        />
                                                    </Grid>
                                                ))}

                                            </React.Fragment>

                                        ))}

                                    </Grid>
                                </Box>
                            </Paper>

                            {/* ------------------ REGULATORY INFORMATION------------------------*/}
                            <Paper elevation={3} className='mt-3 review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Regulatory  Information
                                            </Typography>
                                            <Divider />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is there a power of attorney for {hData.p_first_name} {hData.p_last_name}:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_power_of_attorney)}</span>
                                            </Typography>
                                        </Grid>

                                        {hData.regulatory_power_of_attorney === 1 &&
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">First Name: </span>
                                                        <span className="bold-text">{hData.poa_first_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Last Name: </span>
                                                        <span className="bold-text">{hData.poa_last_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Middle initial: </span>
                                                        <span className="bold-text">{hData.poa_middle_name}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Gender: </span>
                                                        <span className="bold-text">{getGenderLabel(hData.poa_gender)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{getCountryLabel(hData.poa_citizenship)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">SIN: </span>
                                                        <span className="bold-text">{hData.poa_sin}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Relationship to you: </span>
                                                        <span className="bold-text">{getRelationsLabel(hData.poa_relationship_to_you)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Typography component={'h3'} className='form-head-gray-title' sx={{ backgroundColor: "transparent", fontWeight: 600 }}>
                                                        Address
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Street No: </span>
                                                        <span className="bold-text">{hData.poa_street_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Street Name: </span>
                                                        <span className="bold-text">{hData.poa_street_name}</span>
                                                    </Typography>
                                                </Grid>


                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> Unit/Apt No: </span>
                                                        <span className="bold-text">{hData.poa_unit_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text"> City: </span>
                                                        <span className="bold-text">{hData.poa_city}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Province: </span>
                                                        <span className="bold-text">{getProvinceLabel(hData.poa_province)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Country: </span>
                                                        <span className="bold-text">{getCountryLabel(hData.poa_country)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Postal Code: </span>
                                                        <span className="bold-text">{(hData.poa_postal_code)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Home Phone: </span>
                                                        <span className="bold-text">{hData.poa_home_phone_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Cell Phone: </span>
                                                        <span className="bold-text">{hData.poa_cell_phone_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Business Phone: </span>
                                                        <span className="bold-text">{hData.poa_business_phone_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Email: </span>
                                                        <span className="bold-text">{hData.poa_email}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Employment Status: </span>
                                                        <span className="bold-text">{getEmploymentLabel(hData.poa_employment_status)}</span>
                                                    </Typography>
                                                </Grid>



                                                {(hData.poa_employment_status === 1 || hData.poa_employment_status === 2 || hData.poa_employment_status === 3) ?
                                                    <>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Employer: </span>
                                                                <span className="bold-text">{(hData.poa_emp_name)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        {hData.poa_employment_status == 3 &&
                                                            <Grid item xs={12} sm={6}>
                                                                <Typography component="h2" className="primary-account-holder">
                                                                    <span className="light-text">Date of Retirement: </span>
                                                                    <span className="bold-text">{(hData.poa_emp_retirement_date)}</span>
                                                                </Typography>
                                                            </Grid>
                                                        }

                                                        <Grid item xs={12}>
                                                            <Typography component={'h3'} className='form-head-gray-title' sx={{ backgroundColor: "transparent", fontWeight: 600 }}>
                                                                Employment Address
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Street No: </span>
                                                                <span className="bold-text">{hData.poa_emp_street_no}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Street Name: </span>
                                                                <span className="bold-text">{hData.poa_emp_street_name}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Apt No: </span>
                                                                <span className="bold-text">{hData.poa_emp_apartment_no}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> City: </span>
                                                                <span className="bold-text">{hData.poa_emp_city}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Postal Code: </span>
                                                                <span className="bold-text">{(hData.poa_emp_postal_code)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Province: </span>
                                                                <span className="bold-text">{getProvinceLabel(hData.poa_emp_province)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Country: </span>
                                                                <span className="bold-text">{getCountryLabel(hData.poa_emp_country)}</span>
                                                            </Typography>
                                                        </Grid>


                                                    </>
                                                    : ''}
                                            </>
                                        }

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Insider:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_insider)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Shareholder(10%):</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_shareholder_ten)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Shareholder(20%):</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_shareholder_twenty)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">CIRO Member:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_ciro_member)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Do you wish to designate a trusted contact person:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_trusted_contact)}</span>
                                            </Typography>
                                        </Grid>

                                        {hData.regulatory_trusted_contact == 1 &&
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Name: </span>
                                                        <span className="bold-text">{hData.tcp_client_name}</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Phone no: </span>
                                                        <span className="bold-text">{hData.tcp_client_phone_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Email: </span>
                                                        <span className="bold-text">{hData.tcp_client_email}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Relationship to you: </span>
                                                        <span className="bold-text">{getRelationsLabel(hData.tcp_client_relationship_to_you)}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Name: </span>
                                                        <span className="bold-text">{hData.tcp_joint_app_name}</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Phone no: </span>
                                                        <span className="bold-text">{hData.tcp_joint_app_phone_no}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Email: </span>
                                                        <span className="bold-text">{hData.tcp_joint_app_email}</span>
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Typography component="h2" className="primary-account-holder">
                                                        <span className="light-text">Relationship to you: </span>
                                                        <span className="bold-text">{getRelationsLabel(hData.tcp_joint_app_relationship_to_you)}</span>
                                                    </Typography>
                                                </Grid>

                                            </>
                                        }

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you foreign PEP:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_foreign_pep)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you family member or close associate of a foreign PEP:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_associated_foreign_pep)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you domestic PEP:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_domestic_pep)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you family member or close associate of a domestic PEP:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_associated_domestic_pep)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you a HIO:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_hio)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Are you family member or close associate of a HIO:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.regulatory_associated_hio)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                AML & QI Verification
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is there representative register in the province or country of the account holder:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.aml_representative_register ?? 1)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">What is the origin of your contact with the applicant:</span>
                                                <span className="bold-text">{getOriginOfContactLabel(hData.regulatory_contact_application ?? 3)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">How long have you known the applicant: </span>
                                                <span className="bold-text">
                                                    {hData.known_applicant_years} {hData.known_applicant_years == 1 ? 'Year' : 'Years'}{''} & {''}
                                                    {hData.known_applicant_months} {hData.known_applicant_months == 1 ? 'Month' : 'Months'}
                                                </span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Have you met the applicant in person to conduct tha AML & QI verification:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.known_applicant_months)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">AML/QI Method:</span>
                                                <span className="bold-text">{getAmlQiVerificationLabel(hData.aml_method)}</span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Identification Documents
                                            </Typography>
                                            <Divider />
                                        </Grid>

                                        <Box
                                            sx={{
                                                // height: 400,
                                                marginTop: 1,
                                                width: 1,
                                                '& .odd': {
                                                    bgcolor: '#f5f5f5'
                                                },
                                                '& .even': {
                                                    bgcolor: '#eee'
                                                }
                                            }}
                                        >
                                            <div className="upload-section">
                                                <p className="upload-section-subtitle">
                                                    Supported files: PDF, PNG, JPEG, JPG.
                                                </p>
                                                <div className="upload-container">
                                                    <div className="upload-item">
                                                        <label htmlFor="idProof" className="upload-label">ID Proof:</label>
                                                        <div className="upload-input-wrapper">
                                                            {regulatoryFiles?.id_proof_file ?
                                                                <span className="file-details">
                                                                    <span className="file-name">{regulatoryFiles?.id_proof_file}</span>
                                                                    <IconButton
                                                                        aria-label="Download file"
                                                                        onClick={() => downloadRegulatoryFile(regulatoryFiles?.id_proof_file, 1)}
                                                                    >
                                                                        <DownloadIcon />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        aria-label="Delete file"
                                                                        onClick={() => deleteRegulatoryFile("id_proof_file", 1)}
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </span>
                                                                :
                                                                <>
                                                                    {/* <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                                        Upload
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            accept=".pdf,.jpeg,.jpg,.png"
                                                                            onChange={(e) => uploadHandler(e, "id_proof_file")}
                                                                        />
                                                                    </Button> */}
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="upload-item">
                                                        <label htmlFor="driverLicense" className="upload-label">Driver License:</label>
                                                        <div className="upload-input-wrapper">
                                                            {
                                                                regulatoryFiles?.driver_license_file ?
                                                                    <span className="file-details">
                                                                        <span className="file-name">{regulatoryFiles.driver_license_file}</span>
                                                                        <IconButton
                                                                            aria-label="Download file"
                                                                            onClick={() => downloadRegulatoryFile(regulatoryFiles.driver_license_file, 2)}
                                                                        >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            aria-label="Delete file"
                                                                            onClick={() => deleteRegulatoryFile("driver_license_file", 2)}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <Typography component="h2" className="primary-account-holder mt-2">
                                                                            <span className="light-text">File Not Found</span>
                                                                        </Typography>
                                                                        {/*  <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                                            Upload
                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                // id="driverLicense"
                                                                                accept=".pdf,.jpeg,.jpg,.png"
                                                                                onChange={(e) => uploadHandler(e, "driver_license_file")}
                                                                            />
                                                                        </Button> */}
                                                                    </>
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className="upload-item">
                                                        <label htmlFor="passport" className="upload-label">Passport:</label>
                                                        <div className="upload-input-wrapper">

                                                            {
                                                                regulatoryFiles?.passport_file ?
                                                                    <span className="file-details">
                                                                        <span className="file-name">{regulatoryFiles.passport_file}</span>
                                                                        <IconButton
                                                                            aria-label="Download file"
                                                                            onClick={() => downloadRegulatoryFile(regulatoryFiles.passport_file, 3)}
                                                                        >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            aria-label="Delete file"
                                                                            onClick={() => deleteRegulatoryFile("passport_file", 3)}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <Typography component="h2" className="primary-account-holder mt-2">
                                                                            <span className="light-text">File Not Found</span>
                                                                        </Typography>
                                                                        {/* <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                                            Upload
                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                // id="passport"
                                                                                accept=".pdf,.jpeg,.jpg,.png"
                                                                                onChange={(e) => uploadHandler(e, "passport_file")}
                                                                            />
                                                                        </Button> */}
                                                                    </>
                                                            }
                                                            {/* {regulatoryFiles.passport_file && <span className="file-name">{regulatoryFiles.passport_file}</span>} */}
                                                        </div>
                                                    </div>
                                                    <div className="upload-item">
                                                        <label htmlFor="other" className="upload-label">Other:</label>
                                                        <div className="upload-input-wrapper">
                                                            {
                                                                regulatoryFiles?.other_file ?
                                                                    <span className="file-details">
                                                                        <span className="file-name">{regulatoryFiles.other_file}</span>
                                                                        <IconButton
                                                                            aria-label="Download file"
                                                                            onClick={() => downloadRegulatoryFile(regulatoryFiles.other_file, 4)}
                                                                        >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            aria-label="Delete file"
                                                                            onClick={() => deleteRegulatoryFile("other_file", 4)}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <Typography component="h2" className="primary-account-holder mt-2">
                                                                            <span className="light-text">File Not Found</span>
                                                                        </Typography>
                                                                        {/*  <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                                            Upload
                                                                            <input
                                                                                type="file"
                                                                                hidden
                                                                                // id="other"
                                                                                accept=".pdf,.jpeg,.jpg,.png"
                                                                                onChange={(e) => uploadHandler(e, "other_file")}
                                                                            />
                                                                        </Button> */}
                                                                    </>
                                                            }
                                                            {/* {regulatoryFiles.other_file && <span className="file-name">{regulatoryFiles.other_file}</span>} */}
                                                        </div>
                                                    </div>

                                                    {/* -------- void cheque -------- */}

                                                    <div className="upload-item">
                                                        <label htmlFor="voidCheque" className="upload-label">Void Cheque:</label>
                                                        <div className="upload-input-wrapper">
                                                            {
                                                                regulatoryFiles?.void_cheque_file ?
                                                                    <span className="file-details">
                                                                        <span className="file-name">{regulatoryFiles.void_cheque_file}</span>
                                                                        <IconButton
                                                                            aria-label="Download file"
                                                                            onClick={() => downloadRegulatoryFile(regulatoryFiles.void_cheque_file, 5)}
                                                                        >
                                                                            <DownloadIcon />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            aria-label="Delete file"
                                                                            onClick={() => deleteRegulatoryFile("void_cheque_file", 5)}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <Typography component="h2" className="primary-account-holder mt-2">
                                                                            <span className="light-text">File Not Found</span>
                                                                        </Typography>
                                                                        {/*  <Button startIcon={<CloudUploadIcon />} variant="outlined" component="label">
                                                                            Upload
                                                                            <input
                                                                                type="file"
                                                                                // className="upload-input"
                                                                                // id="voidCheque"
                                                                                hidden
                                                                                accept=".pdf,.jpeg,.jpg,.png"
                                                                                onChange={(e) => uploadHandler(e, "void_cheque_file")}
                                                                            />
                                                                        </Button> */}
                                                                    </>
                                                            }
                                                            {/* {files.driver_license_file && <span className="file-name">{files.driver_license_file}</span>} */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Box>


                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Id Verification
                                            </Typography>
                                            <Divider />
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Id Number:</span>
                                                <span className="bold-text">{hData.dl_number}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Date of Birth:</span>
                                                <span className="bold-text">{hData.dl_dob}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Date of Issue:</span>
                                                <span className="bold-text">{hData.dl_doi}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Date of Expiry:</span>
                                                <span className="bold-text">{hData.dl_doe}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Province or Territory where license issue:</span>
                                                <span className="bold-text">{getProvinceLabel(hData.dl_issued_province)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Date of Doc. Verification:</span>
                                                <span className="bold-text">{hData.dl_date_dov}</span>
                                            </Typography>
                                        </Grid>

                                        {/* <Grid item xs={12} sm={12}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Documents:</span>
                                                {regulatoryFiles?.file_name ?
                                                    <>
                                                        <div>
                                                            <span className="bold-text margin-right10px">{regulatoryFiles.file_name}</span>
                                                            <IconButton
                                                                sx={{ p: "0 10px 0 0" }}
                                                                onClick={() => downloadRegulatoryFile(regulatoryFiles.file_name, regulatoryFiles.id)}
                                                            >
                                                                <CloudDownload sx={{ color: '#2598c4' }} />
                                                            </IconButton>

                                                            <IconButton
                                                                sx={{ p: "0 10px 0 0" }}
                                                                onClick={() => deleteRegulatoryFile(regulatoryFiles.file_name, regulatoryFiles.id)}
                                                            >
                                                                <DeleteIcon sx={{ color: '#dd4747' }} />
                                                            </IconButton>
                                                        </div>
                                                    </>
                                                    :
                                                    ''
                                                }
                                            </Typography>
                                        </Grid> */}



                                        {/* ==================TAX PAYER RESIDENCY ================ */}

                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                Tax Payer Residency
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is {hData.p_first_name} {hData.p_last_name} a tax resident of Canada:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.is_tax_resident_canada || 1)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is {hData.p_first_name} {hData.p_last_name} a tax resident of the United States:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.is_tax_resident_usa || 2)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is {hData.p_first_name} {hData.p_last_name} a tax resident of a jurisdiction other than Canada or the United States:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.is_tax_resident_other || 2)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">SIN:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.sin || hData.p_sin)}</span>
                                            </Typography>
                                        </Grid>
                                        {/* </Grid> */}


                                        {/* ==================W8-BEN ================ */}

                                        <Grid item xs={12}>
                                            <Typography component="h2" variant="h4" gutterBottom sx={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                color: "#3f51b5"
                                            }}
                                                className='text-capitalize'>
                                                W-8 Ben Special Rates and Conditions
                                            </Typography>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is {hData.p_first_name} {hData.p_last_name} wish to make claim for  tax treaty benefits:</span>
                                                <span className="bold-text">{getYesNoLabel(hData.is_tax_benefit || 1)}</span>
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Paper>

                            {/* ------------------ CLIENT GROUP INFORMATION------------------------*/}

                            <Paper elevation={3} className='mt-3 review-box-shadow'>
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={12}>
                                            <Grid item xs={12}>
                                                <Typography component="h2" variant="h4" gutterBottom sx={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                    color: "#3f51b5"
                                                }}
                                                    className='text-capitalize'>
                                                    Client Group Details
                                                </Typography>
                                                <Divider />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Typography component="h2" className="primary-account-holder mt-2">
                                                    <span className="light-text">Name: </span>
                                                    <span className="bold-text">{clientFullName}</span>
                                                </Typography>
                                            </Grid>
                                            <Typography component="h2" className="primary-account-holder">
                                                <Box display="flex" alignItems="center">
                                                    <span className="light-text" >Source of initial Investment? </span>
                                                    <FormControl component="fieldset" variant="standard">
                                                        <FormGroup row>
                                                            {initialInvestmentArray.map((option, index) => (
                                                                <FormControlLabel
                                                                    key={index}
                                                                    control={
                                                                        <Checkbox
                                                                            disabled
                                                                            readOnly
                                                                            sx={{ color: '#000' }}
                                                                            checked={siiArray?.includes(option.value) || false}
                                                                        />
                                                                    }
                                                                    label={option.label}
                                                                />
                                                            ))}
                                                        </FormGroup>
                                                    </FormControl>
                                                </Box>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Disclosure of beneficial Ownership information: </span>
                                                <span className="bold-text">
                                                    {(cData?.client_ownership || 1) == 1 ? 'I Object' : 'I Do Not Object'}
                                                </span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Receiving Security Holder Materials: </span>
                                                <span className="bold-text">{getHolderMaterials(cData?.client_holder_material)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Consent to Electronic Delivery: </span>
                                                <span className="bold-text">{(cData?.client_electronic_delivery || 1) ? 'I Consent' : 'I Do Not Consent'}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Will the client want to view account, account statement, trade confirmation or other documents via the investor portal website: </span>
                                                <span className="bold-text">{getYesNoLabel(cData?.client_view_statement || 1)}</span>
                                            </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Does the Client wish to waive their right to receive trade confirmations: </span>
                                                <span className="bold-text">{getYesNoLabel(cData?.client_waive_trade_confirmations || 1)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is there a third party financial interest: </span>
                                                <span className="bold-text">{getYesNoLabel(cData?.client_third_party_financial_interest || 2)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Does your representative have a direct or indirect interest in the account other than an interest in commissions or fees: </span>
                                                <span className="bold-text">{getYesNoLabel(cData?.client_interest || 2)}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <Typography component="h2" className="primary-account-holder">
                                                <span className="light-text">Is the account operated by a third party: </span>
                                                <span className="bold-text">{getYesNoLabel(cData?.client_account_operated_by_third_party || 2)}</span>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Paper>
                        </>

                    </Grid>
                </Grid >
            }
            {/* <Divider sx={{ marginY: 2 }} /> */}
        </>
    );
};

const AccountComponent = (loadData, aData, setAccountsData, userId) => {


    /*  const deleteAccountStatementFileHandler = async (_name, id) => {
 
         try {
             const result = await showConfirmSweetAlert({
                 title: 'Are you sure?',
                 text: `You will not be able to recover this!`,
                 icon: 'warning',
                 showCancelButton: true,
                 confirmButtonText: 'Yes, delete it!',
                 cancelButtonText: 'No, cancel!',
             });
 
             if (result.isConfirmed) {
 
                 // showLoader()
 
                 const response = await axiosInstance.delete(`api/delete-account-statement-file/${id}/${userId}`);
 
                 if (response.success) {
 
                     // : set files here
                     // setAccountStatementFiles((prevFiles) =>
                     //     prevFiles.filter((file) => file.id !== id)
                     // );
 
                     toast.success(response.message);
                 } else {
                     toast.error(response.message);
                 }
             }
 
         } catch (error) {
             // toast.error(error.message)
            //  console.error(error)
         } finally {
             // hideLoader();
         }
     } */

    const downloadAccountStatementFile = async (_name, id) => {

        try {
            const response = await axiosInstance.get(`api/download-account-statement-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });

            // const contentType = response.headers['content-type'];
            const contentType = response.type;


            if (contentType === 'application/json') {

                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'File not found.');
                };
                reader.readAsText(response.data);
            } else {

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        } finally {
            // hideLoader();
        }
    }


    const downloadTransferInstructionFile = async (transferId, instructionId, fileName) => {

        try {
            const response = await axiosInstance.get(`api/download-transfer-file/${transferId}/${instructionId}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });


            const contentType = response['type'];

            if (contentType && contentType.includes('application/json')) {

                // Handle error response
                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'An error occurred.');
                };
                reader.readAsText(response.data);
            } else {

                // Determine file extension and MIME type
                const extension = getFileExtension(fileName);
                const mimeType = contentTypes[extension] || 'application/octet-stream';

                const url = window.URL.createObjectURL(new Blob([response], { type: mimeType }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }


        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        }
    }

    const deleteTransferInstructionFile = async (account_index, td_index, ti_index, fileName, instructionId) => {

        try {
            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: `You will not be able to recover this!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                const data = { file_name: fileName, user_id: userId, id: instructionId }

                const response = await axiosInstance.post(`api/delete-transfer-file`, data);

                if (response.success) {

                    const updatedPolicies = [...aData];

                    updatedPolicies[account_index].transfer_details[td_index].transfer_instruction[ti_index].ti_file = '';

                    setAccountsData(updatedPolicies)

                    toast.success(response.message);

                } else {
                    toast.error(response.message);
                }
            }

        } catch (error) {
            // toast.error(error.message)
            // console.error(error)
        }
    }

    /*  const downloadBankingFile = async (id, fileName) => {
 
         try {
             const response = await axiosInstance.get(`api/download-bank-file/${id}/${userId}`, {
                 responseType: 'blob',
                 validateStatus: (status) => {
                     return status >= 200 && status < 500;
                 },
             });
 
 
             const contentType = response['type'];
 
             if (contentType && contentType.includes('application/json')) {
 
                 // Handle error response
                 const reader = new FileReader();
                 reader.onload = () => {
                     const errorResponse = JSON.parse(reader.result);
                     toast.error(errorResponse.error || 'An error occurred.');
                 };
                 reader.readAsText(response.data);
             } else {
 
                 // Determine file extension and MIME type
                 const extension = getFileExtension(fileName);
                 const mimeType = contentTypes[extension] || 'application/octet-stream';
 
                 const url = window.URL.createObjectURL(new Blob([response], { type: mimeType }));
                 const link = document.createElement('a');
                 link.href = url;
                 link.setAttribute('download', fileName);
                 document.body.appendChild(link);
                 link.click();
                 link.remove();
             }
 
 
         } catch (error) {
             toast.error('An error occurred while downloading the file.');
            //  console.error('Error downloading the file', error);
 
         }
     }
 
     const deleteBankingFile = async (account_index, index, id) => {
 
         try {
 
             const result = await showConfirmSweetAlert({
                 title: 'Are you sure?',
                 text: `You will not be able to recover this!`,
                 icon: 'warning',
                 showCancelButton: true,
                 confirmButtonText: 'Yes, delete it!',
                 cancelButtonText: 'No, cancel!',
             });
 
             if (result.isConfirmed) {
 
                 const data = { user_id: userId, id: id }
 
                 const response = await axiosInstance.post(`api/delete-bank-file`, data);
 
                 if (response.success) {
 
                     const updatedPolicies = [...aData];
 
                     updatedPolicies[account_index].bank_details[index].void_cheque_file = '';
 
                     setAccountsData(updatedPolicies)
 
                     toast.success(response.message);
 
                 } else {
                     toast.error(response.message);
                 }
             }
 
         } catch (error) {
             // toast.error(error.message)
            //  console.error(error)
         }
     } */

    return (
        <>
            {loadData &&
                <Grid container spacing={2}>
                    {aData?.map((accountRow, accountIndex) => {

                        let addTransferDetails = accountRow?.transfer_details

                        return (
                            <React.Fragment key={accountIndex}>
                                <Grid item xs={12} sm={6} md={12}>
                                    <Grid item xs={12}>
                                        <Typography variant='h3' className='form-head-gray-title client-main-title'>Account Type Information</Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                        <Grid item xs={5} sm={5} md={5}>
                                            <label className='font18px font-weight500px'>Non-Registered Account</label>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        {accountRow.account_type_details?.person_non_register_accounts?.map((item, index) => {

                                            return (
                                                <>
                                                    <div className="d-flex">
                                                        <input
                                                            className="custom-checkbox"
                                                            id={`account_non_reg_type${item.value}`}
                                                            type="checkbox"
                                                            readOnly
                                                            // onChange={(e) => handleCheckPrimaryNonRegisterAccount(e, index)}
                                                            checked={item.account_checked}
                                                        />
                                                        <label
                                                            htmlFor={`account_non_reg_type${item.value}`}
                                                            className='label-account-type'
                                                        >
                                                            {item.label}
                                                        </label>

                                                        {/* --------option ----------- */}
                                                        <div className="form-check form-check-inline">
                                                            <FormControlLabel
                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                label="CDN"
                                                                readOnly
                                                                checked={item.account_type_currency == 1}
                                                                // onChange={(e) => changeNonRegAccountCurrency(e, index)}
                                                                name={`account_non_reg_currency${item.value}`}
                                                                id={`s_{item.value}`}
                                                                value={1}
                                                                disabled={item.account_checked == true ? false : true}
                                                            />
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <FormControlLabel
                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                label="USD"
                                                                readOnly
                                                                checked={item.account_type_currency == 2}
                                                                // onChange={(e) => changeNonRegAccountCurrency(e, index)}
                                                                id={`account_non_reg_usd${item.value}`}
                                                                name={`account_non_reg_currency${item.value}`}
                                                                value={2}
                                                                disabled={item.account_checked == true ? false : true}
                                                            />
                                                        </div>
                                                    </div>

                                                    {item.account_checked && (
                                                        <>
                                                            {/*  intended use of accounts..... */}
                                                            <Grid item xs={12} sm={12} md={12} className='ml-10px'>

                                                                <Grid container className="d-flex align-items-center" spacing={2}>
                                                                    <Grid item xs={12} sm={12} md={12} className='text-center'>
                                                                        <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12} className=' text-center ml-10px'>
                                                                        <FormControl
                                                                            required
                                                                            component="fieldset"
                                                                            variant="standard"
                                                                        >
                                                                            <FormGroup>
                                                                                {useOfAccountArray.map((option) => (
                                                                                    <FormControlLabel
                                                                                        key={option.value}
                                                                                        className="custom-form-control-label"
                                                                                        control={
                                                                                            <Checkbox
                                                                                                sx={checkboxColorSx}
                                                                                                checked={item.intended_use_of_account.includes(option.value)}
                                                                                                readOnly
                                                                                            // onChange={(e) => handleIntendedUseChange(e, item.value, option.value)}
                                                                                            />
                                                                                        }
                                                                                        label={option.label}
                                                                                    />
                                                                                ))}
                                                                            </FormGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>

                                                                {/*------------- EFT----------- */}
                                                                <Grid container className="d-flex align-items-center mt-2" spacing={2}>
                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                        <label htmlFor="non-reg-eft" className="font15px pr-10px">Electronics Fund Transfer</label>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={6} md={6} className="d-flex">
                                                                        <FormControl component="fieldset">
                                                                            <RadioGroup
                                                                                row
                                                                                id="non-reg-eft"
                                                                                aria-labelledby="account_eft"
                                                                                name="account_eft"
                                                                                value={item.account_eft || ''}
                                                                            // onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                            // {...register('account_eft', { onChange: (e) => handleChangeNonRegAccountData(e, index) })}
                                                                            >
                                                                                {radioOptionArray.map((option) => (
                                                                                    <FormControlLabel
                                                                                        key={option.value}
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                ))}
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} sx={{ color: '#e05e5ecf' }} className='align-self-center text-center font14px'>
                                                                    Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                </Grid>

                                                                {/*------------- Transfers----------- */}

                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                        <label htmlFor="account_transfer" className='font15px pr-10px'>Transfers</label>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                        <FormControl component="fieldset">
                                                                            <RadioGroup
                                                                                row
                                                                                id='account_transfer'
                                                                                name='account_transfer'
                                                                                aria-labelledby="account_transfer"
                                                                                value={item.account_transfer || ''}
                                                                            // onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                            // {...register('account_transfer', { onChange: (e) => handleChangeNonRegAccountData(e, index) })}
                                                                            >
                                                                                {radioOptionArray.map((option) => {
                                                                                    return (
                                                                                        <FormControlLabel
                                                                                            value={option.value}
                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                            label={option.label}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>


                                                                {/*------------- PAC----------- */}
                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                        <label htmlFor="account_pac" className='font15px pr-10px'>Pre-Authorization Contribution</label>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                        <FormControl component="fieldset">
                                                                            <RadioGroup
                                                                                row
                                                                                id='account_pac'
                                                                                name='account_pac'
                                                                                aria-labelledby="account_pac"
                                                                                value={item.account_pac || ''}
                                                                            // onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                            // {...register('account_pac', { onChange: (e) => handleChangeNonRegAccountData(e, index) })}
                                                                            >
                                                                                {radioOptionArray.map((option) => {
                                                                                    return (
                                                                                        <FormControlLabel
                                                                                            value={option.value}
                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                            label={option.label}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>

                                                                {/*------------- SWP----------- */}
                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                        <label htmlFor="swp" className='font15px pr-10px'>Systematic Withdrawal Plan</label>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                        <FormControl component="fieldset">
                                                                            <RadioGroup
                                                                                row
                                                                                id='swp'
                                                                                name='account_swp'
                                                                                aria-labelledby="account_swp"
                                                                                value={item.account_swp || ''}
                                                                            // onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                            // {...register('account_swp', { onChange: (e) => handleChangeNonRegAccountData(e, index) })}
                                                                            >
                                                                                {radioOptionArray.map((option) => {
                                                                                    return (
                                                                                        <FormControlLabel
                                                                                            value={option.value}
                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                            label={option.label}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>

                                                                {/*------------- Income sweep----------- */}
                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                        <label htmlFor="income-sweep" className='font15px pr-10px'>Income Sweep</label>
                                                                    </Grid>

                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                        <FormControl component="fieldset">
                                                                            <RadioGroup
                                                                                row
                                                                                id='income-sweep'
                                                                                name='account_income_sweep'
                                                                                aria-labelledby="income-sweep"
                                                                                value={item.account_income_sweep || ''}
                                                                            // onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                            // {...register('account_income_sweep', { onChange: (e) => handleChangeNonRegAccountData(e, index) })}
                                                                            >
                                                                                {radioOptionArray.map((option) => {
                                                                                    return (
                                                                                        <FormControlLabel
                                                                                            value={option.value}
                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                            label={option.label}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </>
                                            );
                                        })}
                                        <Divider className="divider mt-0" />
                                    </Grid>

                                    {/* ---------------------------- Registered Account ---------------------------- */}
                                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                        <Grid item xs={5} sm={5} md={5}>
                                            <label className='font18px font-weight500px'>Registered Account</label>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>

                                        {accountRow.account_type_details?.person_register_accounts?.map((item, regIndex) => {
                                            return (
                                                <>
                                                    <div className="d-flex">
                                                        <input
                                                            className="custom-checkbox"
                                                            id={`account_type${item.value}`}
                                                            type="checkbox"
                                                            // onChange={(e) => handleCheckPrimaryRegisterAccount(e, regIndex)}
                                                            checked={item.account_checked}
                                                            readOnly
                                                        />
                                                        <label
                                                            htmlFor={`account_type${item.value}`}
                                                            className='account-type-label'
                                                        >
                                                            {item.label}
                                                        </label>

                                                        <div
                                                            className="form-check form-check-inline"
                                                        >
                                                            <FormControlLabel
                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                label="CDN"
                                                                checked={item.account_type_currency == 1}
                                                                readOnly
                                                                // onChange={(e) => changeRegAccountCurrency(e, regIndex)}
                                                                name={`account_currency${item.value}`}
                                                                id={`account_cdn${item.value}`}
                                                                value={1}
                                                                disabled={item.account_checked == true ? false : true}
                                                            />
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <FormControlLabel
                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                label="USD"
                                                                checked={item.account_type_currency == 2}
                                                                readOnly
                                                                // onChange={(e) => changeRegAccountCurrency(e, regIndex)}
                                                                id={`account_usd${item.value}`}
                                                                name={`account_currency${item.value}`}
                                                                value={2}
                                                                disabled={item.account_checked == true ? false : true}
                                                            />
                                                        </div>
                                                    </div>

                                                    {item.account_checked && (
                                                        // intended use of accounts.....
                                                        <Grid item xs={12} sm={12} md={12} className='ml-10px'>
                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                <Grid item xs={12} sm={12} md={12} className='text-center'>
                                                                    <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} className=' text-center ml-10px'>
                                                                    <FormControl
                                                                        required
                                                                        component="fieldset"
                                                                        variant="standard"
                                                                    >
                                                                        <FormGroup>
                                                                            {useOfAccountArray.map((option) => (
                                                                                <FormControlLabel
                                                                                    key={option.value}
                                                                                    className="custom-form-control-label"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            sx={{
                                                                                                ...checkboxColorSx,
                                                                                                fontSize: "14px",
                                                                                                width: "max-content"
                                                                                            }}
                                                                                            checked={item.intended_use_of_account.includes(option.value)}
                                                                                            readOnly
                                                                                        // onChange={(e) => handleRegIntendedUseChange(e, item.value, option.value)}
                                                                                        />
                                                                                    }
                                                                                    label={option.label}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>


                                                            <Grid container className="d-flex align-items-center mt-2" spacing={2}>

                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                    <label htmlFor="eft" className='font15px pr-10px'>Electronics Fund transfer</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            row
                                                                            id='eft'
                                                                            aria-labelledby="account_eft"
                                                                            name="account_eft"
                                                                            value={item.account_eft || ''}
                                                                        // onChange={(e) => handleChangeRegAccountData(e, regIndex)}
                                                                        // {...register('account_eft', { onChange: (e) => handleChangeRegAccountData(e, regIndex, 'account_eft') })}

                                                                        >
                                                                            {radioOptionArray.map((option) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>


                                                            <Grid item xs={12} sm={12} md={12} sx={{ color: '#e05e5ecf' }} className='align-self-center text-center font14px'>
                                                                Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                            </Grid>

                                                            {/*------------- Transfers----------- */}
                                                            <Grid container className="d-flex align-items-center" spacing={2}>

                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                    <label htmlFor="account_transfer" className='font15px pr-10px'>Transfers</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            row
                                                                            id='account_transfer'
                                                                            name="account_transfer"
                                                                            aria-labelledby="account_transfer"
                                                                            value={item.account_transfer || ''}
                                                                        // onChange={(e) => handleChangeRegAccountData(e, regIndex)}

                                                                        // {...register('account_transfer', { onChange: (e) => handleChangeRegAccountData(e, regIndex, 'account_transfer') })}
                                                                        >
                                                                            {radioOptionArray.map((option) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid></Grid>


                                                            {/*------------- PAC----------- */}
                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                <Grid item xs={12} sm={8} md={6} className={`align-content-center text-right`}>
                                                                    <label className='font15px pr-10px'>Pre-Authorization Contribution</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={4} md={6}>
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            row
                                                                            // id='pac'
                                                                            aria-labelledby="account_pac"
                                                                            name="account_pac"
                                                                            value={item.account_pac || ''}
                                                                        // onChange={(e) => handleChangeRegAccountData(e, regIndex)}
                                                                        // {...register('account_pac', { onChange: (e) => handleChangeRegAccountData(e, regIndex, 'account_pac') })}
                                                                        >
                                                                            {radioOptionArray.map((option) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>

                                                            {/*------------- SWP----------- */}
                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                    <label className='font15px pr-10px'>Systematic Withdrawal Plan</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            row
                                                                            // id='swp'
                                                                            aria-labelledby="account_swp"
                                                                            name="account_swp"
                                                                            value={item.account_swp || ''}
                                                                        // onChange={(e) => handleChangeRegAccountData(e, regIndex)}
                                                                        // {...register('account_swp', { onChange: (e) => handleChangeRegAccountData(e, regIndex, 'account_swp') })}
                                                                        >
                                                                            {radioOptionArray.map((option) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>

                                                            {/*------------- Income sweep----------- */}
                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                    <label /* htmlFor="income-sweep" */ className='font15px pr-10px'>Income Sweep</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={6}>
                                                                    <FormControl component="fieldset">
                                                                        <RadioGroup
                                                                            row
                                                                            // id='income-sweep'
                                                                            aria-labelledby="income-sweep"
                                                                            name="account_income_sweep"
                                                                            value={item.account_income_sweep || ''}
                                                                        // onChange={(e) => handleChangeRegAccountData(e, regIndex)}
                                                                        // {...register('account_income_sweep', { onChange: (e) => handleChangeRegAccountData(e, regIndex, 'account_income_sweep') })}
                                                                        >
                                                                            {radioOptionArray.map((option) => {
                                                                                return (
                                                                                    <FormControlLabel
                                                                                        value={option.value}
                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                        label={option.label}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid >

                                                    )}
                                                </>
                                            );
                                        })
                                        }

                                        <Divider className="divider  mt-0" />
                                    </Grid>

                                    {/* --------------spousal account data -------------- */}


                                    <Grid item xs={12} sm={12} md={12} className='mt-3'>
                                        <Grid container className="d-flex align-items-center" spacing={2}>
                                            <Grid item xs={12} sm={12} md={12} className='text-left'>
                                                <FormLabel className='font16px margin-top10px margin-right15px'>Does your Spouse also want to open an account?</FormLabel>

                                                <FormControl component="fieldset">
                                                    <RadioGroup
                                                        row
                                                        // id='swp'
                                                        aria-labelledby="is_spousal_account"
                                                        name="is_spousal_account"
                                                        value={accountRow.account_type_details.is_spousal_account || 2}

                                                    >
                                                        {radioOptionArray.map((option) => {
                                                            return (
                                                                <FormControlLabel
                                                                    value={option.value}
                                                                    control={<Radio sx={radioColorSx} />}
                                                                    label={option.label}
                                                                />
                                                            );
                                                        })}
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>



                                        {(accountRow.account_type_details?.spousal_non_register_accounts.length > 0) &&
                                            <>
                                                <div container className="mt-2">
                                                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <label className='font18px font-weight500px p-2'>Non-Registered Account</label>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12}>
                                                        {accountRow.account_type_details?.spousal_non_register_accounts?.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <div className="d-flex">
                                                                        <input
                                                                            className="custom-checkbox"
                                                                            id={`s_account_non_reg_type${item.value}`}
                                                                            type="checkbox"
                                                                            checked={item.account_checked}
                                                                            readOnly
                                                                        />
                                                                        <label
                                                                            htmlFor={`s_account_non_reg_type${item.value}`}
                                                                            className='label-account-type'
                                                                        >
                                                                            {item.label}
                                                                        </label>

                                                                        {/* --------option ----------- */}
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="CDN"
                                                                                checked={item.account_type_currency == 1}
                                                                                readOnly
                                                                                name={`s_account_non_reg_currency${item.value}`}
                                                                                id={`s_account_non_reg_cdn${item.value}`}
                                                                                value={1}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="USD"
                                                                                checked={item.account_type_currency == 2}
                                                                                readOnly
                                                                                id={`s_account_non_reg_usd${item.value}`}
                                                                                name={`s_account_non_reg_currency${item.value}`}
                                                                                value={2}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {item.account_checked && (
                                                                        <>
                                                                            {/*  intended use of accounts..... */}
                                                                            <Grid item xs={12} sm={12} md={12} className='ml-10px'>

                                                                                <Grid container className="d-flex align-items-center" spacing={2}>
                                                                                    <Grid item xs={12} sm={12} md={12} className='text-center'>
                                                                                        <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={12} md={12} className=' text-center ml-10px'>
                                                                                        <FormControl
                                                                                            required
                                                                                            component="fieldset"
                                                                                            variant="standard"
                                                                                        >
                                                                                            <FormGroup>
                                                                                                {useOfAccountArray.map((option) => (
                                                                                                    <FormControlLabel
                                                                                                        key={option.value}
                                                                                                        className="custom-form-control-label"
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                sx={checkboxColorSx}
                                                                                                                checked={item.intended_use_of_account.includes(option.value)}
                                                                                                                readOnly
                                                                                                            />
                                                                                                        }
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                ))}
                                                                                            </FormGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                {/*------------- EFT----------- */}
                                                                                <Grid container className="d-flex align-items-center mt-2" spacing={2}>
                                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                        <label htmlFor="non-reg-eft" className="font15px pr-10px">Electronics Fund Transfer</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={6} md={6} className="d-flex">
                                                                                        <FormControl component="fieldset">
                                                                                            <RadioGroup
                                                                                                row
                                                                                                id="non-reg-eft"
                                                                                                aria-labelledby="account_eft"
                                                                                                name="account_eft"
                                                                                                value={item.account_eft || ''}
                                                                                            >
                                                                                                {radioOptionArray.map((option) => (
                                                                                                    <FormControlLabel
                                                                                                        key={option.value}
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                ))}
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={12} md={12} sx={{ color: '#e05e5ecf' }} className='align-self-center text-center font14px'>
                                                                                    Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                                </Grid>

                                                                                {/*------------- Transfers----------- */}

                                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                        <label htmlFor="account_transfer" className='font15px pr-10px'>Transfers</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        <FormControl component="fieldset">
                                                                                            <RadioGroup
                                                                                                row
                                                                                                id='account_transfer'
                                                                                                name='account_transfer'
                                                                                                aria-labelledby="account_transfer"
                                                                                                value={item.account_transfer || ''}
                                                                                            >
                                                                                                {radioOptionArray.map((option) => {
                                                                                                    return (
                                                                                                        <FormControlLabel
                                                                                                            value={option.value}
                                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                                            label={option.label}
                                                                                                        />
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>


                                                                                {/*------------- PAC----------- */}
                                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                        <label htmlFor="account_pac" className='font15px pr-10px'>Pre-Authorization Contribution</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        <FormControl component="fieldset">
                                                                                            <RadioGroup
                                                                                                row
                                                                                                id='account_pac'
                                                                                                name='account_pac'
                                                                                                aria-labelledby="account_pac"
                                                                                                value={item.account_pac || ''}
                                                                                            >
                                                                                                {radioOptionArray.map((option) => {
                                                                                                    return (
                                                                                                        <FormControlLabel
                                                                                                            value={option.value}
                                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                                            label={option.label}
                                                                                                        />
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                {/*------------- SWP----------- */}
                                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                        <label htmlFor="swp" className='font15px pr-10px'>Systematic Withdrawal Plan</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        <FormControl component="fieldset">
                                                                                            <RadioGroup
                                                                                                row
                                                                                                id='swp'
                                                                                                name='account_swp'
                                                                                                aria-labelledby="account_swp"
                                                                                                value={item.account_swp || ''}
                                                                                            >
                                                                                                {radioOptionArray.map((option) => {
                                                                                                    return (
                                                                                                        <FormControlLabel
                                                                                                            value={option.value}
                                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                                            label={option.label}
                                                                                                        />
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                {/*------------- Income sweep----------- */}
                                                                                <Grid container className="d-flex align-items-center" spacing={2}>

                                                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                        <label htmlFor="income-sweep" className='font15px pr-10px'>Income Sweep</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={6} md={6}>
                                                                                        <FormControl component="fieldset">
                                                                                            <RadioGroup
                                                                                                row
                                                                                                id='income-sweep'
                                                                                                name='account_income_sweep'
                                                                                                aria-labelledby="income-sweep"
                                                                                                value={item.account_income_sweep || ''}
                                                                                            >
                                                                                                {radioOptionArray.map((option) => {
                                                                                                    return (
                                                                                                        <FormControlLabel
                                                                                                            value={option.value}
                                                                                                            control={<Radio sx={radioColorSx} />}
                                                                                                            label={option.label}
                                                                                                        />
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                        <Divider className="divider  mt-0" />
                                                    </Grid>

                                                    {/* --------spousal register account ----------- */}

                                                    <Grid item xs={12} sm={12} md={12} className='d-flex mt-3'>
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <label className='font18px font-weight500px p-2'>Registered Account</label>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12}>
                                                        {accountRow.account_type_details?.spousal_register_accounts?.map((item, regIndex) => {

                                                            return (
                                                                <>
                                                                    <div className="d-flex">
                                                                        <input
                                                                            className="custom-checkbox"
                                                                            id={`spousal_reg_account_type${item.value}`}
                                                                            type="checkbox"
                                                                            // onChange={(e) => handleCheckSpousalRegisterAccount(e, regIndex)}
                                                                            checked={item.account_checked}
                                                                            readOnly
                                                                        />
                                                                        <label
                                                                            htmlFor={`spousal_reg_account_type${item.value}`}
                                                                            className='account-type-label'
                                                                        >
                                                                            {item.label}
                                                                        </label>

                                                                        <div
                                                                            className="form-check form-check-inline"
                                                                        >
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="CDN"
                                                                                checked={item.account_type_currency == 1}
                                                                                readOnly
                                                                                // onChange={(e) => changeSpousalRegAccountCurrency(e, regIndex)}
                                                                                name={`spousal_reg_account_currency${item.value}`}
                                                                                id={`spousal_reg_account_cdn${item.value}`}
                                                                                value={1}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="USD"
                                                                                checked={item.account_type_currency == 2}
                                                                                readOnly
                                                                                // onChange={(e) => changeSpousalRegAccountCurrency(e, regIndex)}
                                                                                id={`spousal_reg_account_usd${item.value}`}
                                                                                name={`spousal_reg_account_currency${item.value}`}
                                                                                value={2}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {item.account_checked && (
                                                                        // intended use of accounts.....
                                                                        <Grid item xs={12} sm={12} md={12} className='ml-10px'>
                                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                                <Grid item xs={12} sm={12} md={12} className='text-center'>
                                                                                    <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={12} md={12} className=' text-center ml-10px'>
                                                                                    <FormControl
                                                                                        required
                                                                                        component="fieldset"
                                                                                        variant="standard"
                                                                                    >
                                                                                        <FormGroup>
                                                                                            {useOfAccountArray.map((option) => (
                                                                                                <FormControlLabel
                                                                                                    key={option.value}
                                                                                                    className="custom-form-control-label"
                                                                                                    control={
                                                                                                        <Checkbox
                                                                                                            sx={{
                                                                                                                ...checkboxColorSx,
                                                                                                                fontSize: "14px",
                                                                                                                width: "max-content"
                                                                                                            }}
                                                                                                            checked={item.intended_use_of_account.includes(option.value)}
                                                                                                            readOnly
                                                                                                        // onChange={(e) => handleSpousalRegIntendedUseChange(e, item.value, option.value)}
                                                                                                        />
                                                                                                    }
                                                                                                    label={option.label}
                                                                                                />
                                                                                            ))}
                                                                                        </FormGroup>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>


                                                                            <Grid container className="d-flex align-items-center mt-2" spacing={2}>

                                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                    <label htmlFor="eft" className='font15px pr-10px'>Electronics Fund transfer</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <FormControl component="fieldset">
                                                                                        <RadioGroup
                                                                                            row
                                                                                            id='eft'
                                                                                            aria-labelledby="account_eft"
                                                                                            name="account_eft"
                                                                                            value={item.account_eft || ''}
                                                                                        // onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}

                                                                                        >
                                                                                            {radioOptionArray.map((option) => {
                                                                                                return (
                                                                                                    <FormControlLabel
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                );
                                                                                            })}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>


                                                                            <Grid item xs={12} sm={12} md={12} sx={{ color: '#e05e5ecf' }} className='align-self-center text-center font14px'>
                                                                                Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                            </Grid>

                                                                            {/*------------- Transfers----------- */}
                                                                            <Grid container className="d-flex align-items-center" spacing={2}>

                                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                    <label htmlFor="account_transfer" className='font15px pr-10px'>Transfers</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <FormControl component="fieldset">
                                                                                        <RadioGroup
                                                                                            row
                                                                                            id='account_transfer'
                                                                                            name="account_transfer"
                                                                                            aria-labelledby="account_transfer"
                                                                                            value={item.account_transfer || ''}
                                                                                        // onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}
                                                                                        >
                                                                                            {radioOptionArray.map((option) => {
                                                                                                return (
                                                                                                    <FormControlLabel
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                );
                                                                                            })}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </Grid></Grid>


                                                                            {/*------------- PAC----------- */}
                                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                                <Grid item xs={12} sm={8} md={6} className={`align-content-center text-right`}>
                                                                                    <label className='font15px pr-10px'>Pre-Authorization Contribution</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={4} md={6}>
                                                                                    <FormControl component="fieldset">
                                                                                        <RadioGroup
                                                                                            row
                                                                                            // id='pac'
                                                                                            aria-labelledby="account_pac"
                                                                                            name="account_pac"
                                                                                            value={item.account_pac || ''}
                                                                                        // onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}
                                                                                        >
                                                                                            {radioOptionArray.map((option) => {
                                                                                                return (
                                                                                                    <FormControlLabel
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                );
                                                                                            })}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>

                                                                            {/*------------- SWP----------- */}
                                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                    <label className='font15px pr-10px'>Systematic Withdrawal Plan</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <FormControl component="fieldset">
                                                                                        <RadioGroup
                                                                                            row
                                                                                            // id='swp'
                                                                                            aria-labelledby="account_swp"
                                                                                            name="account_swp"
                                                                                            value={item.account_swp || ''}
                                                                                        // onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}
                                                                                        >
                                                                                            {radioOptionArray.map((option) => {
                                                                                                return (
                                                                                                    <FormControlLabel
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                );
                                                                                            })}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>

                                                                            {/*------------- Income sweep----------- */}
                                                                            <Grid container className="d-flex align-items-center" spacing={2}>
                                                                                <Grid item xs={12} sm={6} md={6} className={`align-content-center text-right`}>
                                                                                    <label /* htmlFor="income-sweep" */ className='font15px pr-10px'>Income Sweep</label>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6} md={6}>
                                                                                    <FormControl component="fieldset">
                                                                                        <RadioGroup
                                                                                            row
                                                                                            // id='income-sweep'
                                                                                            aria-labelledby="income-sweep"
                                                                                            name="account_income_sweep"
                                                                                            value={item.account_income_sweep || ''}
                                                                                        // onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}
                                                                                        >
                                                                                            {radioOptionArray.map((option) => {
                                                                                                return (
                                                                                                    <FormControlLabel
                                                                                                        value={option.value}
                                                                                                        control={<Radio sx={radioColorSx} />}
                                                                                                        label={option.label}
                                                                                                    />
                                                                                                );
                                                                                            })}
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid >

                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                        <Divider className="divider  mt-0" />
                                                    </Grid>
                                                </div>
                                            </>
                                        }
                                    </Grid>

                                    <Divider className="divider" />

                                    {/* -------------- Account Statement upload ----------------- */}
                                    <Grid item xs={12} sm={12} md={12} className='d-flex mt-3'>
                                        {/* <Grid item xs={12} sm={12} md={5}> */}
                                        <label className='font16px'> Uploaded the statement for any accounts you wish to transfer to us.</label>
                                        {/* </Grid> */}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Box
                                            sx={{
                                                // height: 400,
                                                marginTop: 1,
                                                width: 1,
                                                '& .odd': {
                                                    bgcolor: '#f5f5f5'
                                                },
                                                '& .even': {
                                                    bgcolor: '#eee'
                                                }
                                            }}
                                        >
                                            <div className="file-card min-height-100px">

                                                <p className="main">Supported files</p>
                                                <p className="info">Pdf, Png, Jpeg, jpg</p>

                                                <ul className="file-list width100">
                                                    {accountRow?.account_type_details?.account_statement_files?.map(file => (
                                                        <div className='file-li-class'>
                                                            <li key={file.id} className="file-item">
                                                                <FontAwesomeIcon icon={faFileAlt} className='margin-right10px' />
                                                                <p className='mb-0'>{file.file_name}</p>
                                                                <div className="actions">
                                                                    <FontAwesomeIcon className='margin-right10px' icon={faDownload} onClick={() => downloadAccountStatementFile(file.file_name, file.id)} />
                                                                    {/* <FontAwesomeIcon  icon={faTrash} onClick={() => deleteAccountStatementFileHandler(file.file_name, file.id)} /> */}
                                                                </div>
                                                            </li>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Box>
                                    </Grid>

                                    {/* ---------------------- BENEFICIARY INFORMATION--------------------- */}

                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            {/* <Grid container spacing={2}> */}
                                            <Grid item xs={12} sm={6} md={12}>
                                                <Grid item xs={12}>
                                                    <Typography variant='h3' className='form-head-gray-title client-main-title'>Beneficiary Information</Typography>
                                                </Grid>
                                            </Grid>
                                            <div className="beneficiary-box">
                                                <Grid item className='d-flex'>


                                                    <Grid item xs={12} sm={6} md={6} className={`align-content-center text-left`}>
                                                        <label htmlFor="elect-beneficiary" className='font15px'>Does the account holder wish to elect Beneficiaries for this account?</label>
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4} className='margin-left10px'>
                                                        <FormControl component='fieldset'>
                                                            <RadioGroup
                                                                row
                                                                name="elect_account_beneficiary"
                                                                id='elect-beneficiary'
                                                                value={accountRow?.beneficiary_information?.elect_account_beneficiary || ''}
                                                            >
                                                                {radioOptionArray.map((row) => (
                                                                    <FormControlLabel
                                                                        key={row.value}
                                                                        value={row.value}
                                                                        control={
                                                                            <Radio
                                                                                sx={radioColorSx}
                                                                            />
                                                                        }
                                                                        label={row.label}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>



                                                {(accountRow?.beneficiary_information?.elect_account_beneficiary == 1) && (
                                                    <>
                                                        <div className='width100 padding10px'>

                                                            {accountRow?.beneficiary_information?.elect_account_beneficiary_details.map((beneficiary, index) => {
                                                                return (
                                                                    <>
                                                                        {/* ----------person account details ------------- */}

                                                                        <Grid
                                                                            xs={12} sm={12} md={12}
                                                                            direction="row"
                                                                            justifyContent="space-between"
                                                                            alignItems="center"
                                                                            className='form-head-gray-title mt-2 d-flex'
                                                                        >

                                                                            <Grid item>
                                                                                <Typography component={'h3'}>Beneficiary Details #{index + 1}</Typography>
                                                                            </Grid>
                                                                        </Grid>

                                                                        <Grid container spacing={2}>
                                                                            {(beneficiary.primary_non_reg_count > 0 || beneficiary.primary_reg_count > 0) &&
                                                                                <Grid item xs={12} sm={12} md={12} className={`align-content-center text-left`}>
                                                                                    <label htmlFor="elect-beneficiary" className='label-text'>Primary's account</label>
                                                                                </Grid>
                                                                            }


                                                                            <Grid item xs={6}>
                                                                                {(beneficiary.primary_reg_count > 0) && (
                                                                                    <>
                                                                                        <label className="font18px">Registered Account</label>
                                                                                        {beneficiary.primary?.map((item, bRegPersonIndex) => (
                                                                                            <div key={bRegPersonIndex} className="beneficiary-section p-1">

                                                                                                {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                                                    <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            disabled
                                                                                                            className="asset_checkbox-1 font16px"
                                                                                                            id={`p_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                            checked={itemRow.account_checked || false} // Ensure a default value

                                                                                                        />
                                                                                                        <label
                                                                                                            htmlFor={`p_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                            className='account-label-text'
                                                                                                        >
                                                                                                            {itemRow.label}
                                                                                                        </label>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            </Grid>
                                                                        </Grid >

                                                                        <Divider className='divider' />
                                                                        {/* ----------spouse account details ------------- */}
                                                                        <Grid container spacing={2} className='mt-3'>

                                                                            {(beneficiary.spousal_non_reg_count > 0 || beneficiary.spousal_reg_count > 0) &&
                                                                                <Grid item xs={12} sm={12} md={12} className={`align-content-center pt-0 text-left`}>
                                                                                    <label htmlFor="elect-beneficiary" className='label-text'>Spouse's account</label>
                                                                                </Grid>
                                                                            }

                                                                            <Grid item xs={6}>
                                                                                {beneficiary.spousal_reg_count > 0 && (
                                                                                    <>
                                                                                        <label className="font18px">Registered Account</label>
                                                                                        {beneficiary.spouse?.map((item, bRegPersonIndex) => (
                                                                                            <div key={bRegPersonIndex} className="beneficiary-section  p-1">

                                                                                                {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                                                    <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            disabled
                                                                                                            className="asset_checkbox-1 font16px"
                                                                                                            id={`s_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                            checked={itemRow.account_checked || false} // Ensure a default value

                                                                                                        />
                                                                                                        <label
                                                                                                            htmlFor={`s_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                            className='account-label-text'
                                                                                                        >
                                                                                                            {itemRow.label}
                                                                                                        </label>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            </Grid>
                                                                        </Grid>

                                                                        {
                                                                            beneficiary?.details?.map((row, dIndex) => {

                                                                                return (
                                                                                    <>
                                                                                        <Grid
                                                                                            xs={12} sm={12} md={12}
                                                                                            direction="row"
                                                                                            justifyContent="space-between"
                                                                                            alignItems="center"
                                                                                            className='form-head-gray-title mt-2 d-flex'
                                                                                        >
                                                                                            <Grid item>
                                                                                                <Typography component={'h3'}>Beneficiary Member #{dIndex + 1}</Typography>
                                                                                            </Grid>
                                                                                        </Grid>

                                                                                        <Grid container spacing={2} className='mt-2'>

                                                                                            {(index >= 1) && (
                                                                                                <>
                                                                                                    <Grid item xs={6}>
                                                                                                        <TextField
                                                                                                            label="Beneficiary Member"
                                                                                                            fullWidth
                                                                                                            size="small"
                                                                                                            value={`${row.first_name || ''} ${row.last_name || ''}`}
                                                                                                        // value={row.selected_beneficiary_member || ''}
                                                                                                        />
                                                                                                    </Grid>
                                                                                                </>
                                                                                            )}
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="First Name"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.first_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Middle Initial"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.middle_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Last Name"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.last_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="SIN"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.sin || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Date Of Birth"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.dob || null}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <NumberFormat
                                                                                                    customInput={TextField}
                                                                                                    label="Allocation (%)"
                                                                                                    suffix="%"
                                                                                                    value={row.allocation}
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                />
                                                                                            </Grid>

                                                                                            <Grid item xs={6}>
                                                                                                <FormControl fullWidth size="small">
                                                                                                    <InputLabel>Relationship</InputLabel>
                                                                                                    <Select
                                                                                                        value={row.relation || ''}
                                                                                                        label="Relationship"
                                                                                                        MenuProps={{
                                                                                                            disableScrollLock: true,
                                                                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                                                                        }}
                                                                                                    >
                                                                                                        {relationArray.map((option) => (
                                                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                                                {option.label}
                                                                                                            </MenuItem>
                                                                                                        ))}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                )
                                                            })}
                                                            {/* <Divider className='divider' /> */}
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                            <div className="beneficiary-box width100">
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <div className='d-flex'>
                                                        <Grid item xs={12} sm={6} md={6} className={`align-content-center text-left`}>
                                                            <label htmlFor="elect-beneficiary-01" className='font15px'>Does the account holder wish to elect Contingent Beneficiaries for this account?</label>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <FormControl component='fieldset'>
                                                                <RadioGroup
                                                                    row
                                                                    name="elect_contingent_beneficiary"
                                                                    id='elect-beneficiary-01'
                                                                    value={accountRow.beneficiary_information?.elect_contingent_beneficiary || ''}
                                                                >
                                                                    {radioOptionArray.map((row) => (
                                                                        <FormControlLabel
                                                                            key={row.value}
                                                                            value={row.value}
                                                                            control={
                                                                                <Radio
                                                                                    sx={radioColorSx}
                                                                                />
                                                                            }
                                                                            label={row.label}
                                                                        />
                                                                    ))}
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>
                                                    </div>


                                                    {(accountRow.beneficiary_information?.elect_contingent_beneficiary == 1) && (
                                                        <>
                                                            <div className='width100 padding10px'>

                                                                {accountRow.beneficiary_information?.elect_contingent_account_beneficiary_details.map((beneficiary, index) => {

                                                                    return (
                                                                        <>

                                                                            {/* ----------person account details ------------- */}
                                                                            <Grid
                                                                                xs={12} sm={12} md={12}
                                                                                direction="row"
                                                                                justifyContent="space-between"
                                                                                alignItems="center"
                                                                                className='form-head-gray-title mt-2 d-flex'
                                                                            >
                                                                                <Grid item>
                                                                                    <Typography component={'h3'}>Beneficiary Details #{index + 1}</Typography>
                                                                                </Grid>
                                                                            </Grid>


                                                                            <Grid container spacing={2} className='mt-3'>
                                                                                {(beneficiary.primary_non_reg_count > 0 || beneficiary.primary_reg_count > 0) &&
                                                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center text-left`}>
                                                                                        <label htmlFor="primary-elect-beneficiary" className='label-text'>Primary's account</label>
                                                                                    </Grid>
                                                                                }

                                                                                <Grid item xs={6}>
                                                                                    {(beneficiary.primary_reg_count > 0) &&
                                                                                        (
                                                                                            <>
                                                                                                <label className="font18px">Registered Account</label>
                                                                                                {beneficiary.primary?.map((item, bRegPersonIndex) => (
                                                                                                    <div key={bRegPersonIndex} className="beneficiary-section  p-1">

                                                                                                        {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                                                            <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                                                <input
                                                                                                                    type="checkbox"
                                                                                                                    className="asset_checkbox-1 font16px"
                                                                                                                    id={`p_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                                    checked={itemRow.account_checked || false} // Ensure a default value
                                                                                                                    disabled

                                                                                                                />
                                                                                                                <label
                                                                                                                    htmlFor={`p_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                                    className='account-label-text'
                                                                                                                >
                                                                                                                    {itemRow.label}
                                                                                                                </label>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                ))}
                                                                                            </>
                                                                                        )}
                                                                                </Grid>
                                                                            </Grid>

                                                                            <Divider className='divider' />

                                                                            {/* ----------spouse account details ------------- */}
                                                                            <Grid container spacing={2} className='mt-3'>

                                                                                {(beneficiary.spousal_non_reg_count > 0 || beneficiary.spousal_reg_count > 0) &&
                                                                                    <Grid item xs={12} sm={12} md={12} className={`align-content-center pt-0 text-left`}>
                                                                                        <label htmlFor="spouse-elect-beneficiary" className='label-text'>Spouse's account</label>
                                                                                    </Grid>
                                                                                }

                                                                                <Grid item xs={6}>
                                                                                    {(beneficiary.spousal_reg_count > 0) && (
                                                                                        <>
                                                                                            <label className="font18px">Registered Account</label>
                                                                                            {beneficiary.spouse?.map((item, bRegPersonIndex) => (
                                                                                                <div key={bRegPersonIndex} className="beneficiary-section p-1">

                                                                                                    {item.bene_register_account_type?.map((itemRow, pRegItemRowIndex) => (
                                                                                                        <div className="d-flex ml-10px" key={itemRow.value}>
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className="asset_checkbox-1 font16px"
                                                                                                                id={`s_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                                checked={itemRow.account_checked || false} // Ensure a default value
                                                                                                                disabled

                                                                                                            />
                                                                                                            <label
                                                                                                                htmlFor={`s_contingent_account_reg_type${itemRow.value}_${index}_${pRegItemRowIndex}`}
                                                                                                                className='account-label-text'
                                                                                                            >
                                                                                                                {itemRow.label}
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            ))}
                                                                                        </>
                                                                                    )}
                                                                                </Grid>
                                                                            </Grid>


                                                                            {beneficiary?.details?.map((row, dIndex) => {
                                                                                return (
                                                                                    <>

                                                                                        <Grid
                                                                                            xs={12} sm={12} md={12}
                                                                                            direction="row"
                                                                                            justifyContent="space-between"
                                                                                            alignItems="center"
                                                                                            className='form-head-gray-title mt-2 d-flex'
                                                                                        >
                                                                                            <Grid item>
                                                                                                <Typography component={'h3'}>Beneficiary Member #{dIndex + 1}</Typography>
                                                                                            </Grid>
                                                                                        </Grid>

                                                                                        <Grid container spacing={2} className='mt-2'>
                                                                                            {(index >= 1) && (
                                                                                                <>
                                                                                                    <Grid item xs={6}>
                                                                                                        <TextField
                                                                                                            label="Beneficiary Member"
                                                                                                            fullWidth
                                                                                                            size="small"
                                                                                                            value={`${row.first_name || ''} ${row.last_name || ''}`}
                                                                                                        />
                                                                                                    </Grid>
                                                                                                </>
                                                                                            )}
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="First Name"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.first_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Middle Initial"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.middle_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Last Name"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.last_name || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="SIN"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.sin || ''}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <TextField
                                                                                                    label="Date Of Birth"
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                    value={row.dob || null}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <NumberFormat
                                                                                                    customInput={TextField}
                                                                                                    label="Allocation (%)"
                                                                                                    suffix="%"
                                                                                                    value={row.allocation}
                                                                                                    fullWidth
                                                                                                    size="small"
                                                                                                />
                                                                                            </Grid>


                                                                                            <Grid item xs={6}>
                                                                                                <FormControl fullWidth size="small">
                                                                                                    <InputLabel>Relationship</InputLabel>
                                                                                                    <Select
                                                                                                        value={row.relation || ''}
                                                                                                        label="Relationship"
                                                                                                        MenuProps={{
                                                                                                            disableScrollLock: true,
                                                                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                                                                        }}
                                                                                                        disabled
                                                                                                    >
                                                                                                        {relationArray.map((option) => (
                                                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                                                {option.label}
                                                                                                            </MenuItem>
                                                                                                        ))}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </>
                                                                    )
                                                                })}
                                                                {/* <Divider className='divider' /> */}
                                                            </div>

                                                        </>
                                                    )}

                                                </Grid>
                                            </div>

                                            {/* </Grid > */}
                                        </Box>
                                    </Paper>


                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>

                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Transfer Details
                                                    </Typography>
                                                </Grid>

                                                {addTransferDetails?.map((item, transferIndex) => (
                                                    <div key={transferIndex}>
                                                        <Grid
                                                            xs={12}
                                                            container
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                            className='form-head-gray-title'
                                                        >
                                                            <Grid item>
                                                                <Typography component='h3'>Transfer Details #{transferIndex + 1}</Typography>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid item xs={12} className='align-content-center text-left mt-4'>
                                                            <label htmlFor="irrevocable-beneficiary" className='font15px bold-text'>Irrevocable Beneficiary Information</label>
                                                        </Grid>

                                                        <Grid container sx={{ border: "1px solid #ced4da", p: "10px", mt: "10px" }}>
                                                            <Grid item xs={12} sm={6} className='align-content-center text-left'>
                                                                <label htmlFor="irrevocable-beneficiary" className='font15px'>Is there an irrevocable beneficiary on the account at the delivering institution?</label>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6} md={3}>
                                                                <FormControl component="fieldset">
                                                                    <RadioGroup
                                                                        row
                                                                        id='irrevocable-information'
                                                                        aria-labelledby="irrevocable_information"
                                                                        name='irrevocable_information'
                                                                        value={item.irrevocable_information}
                                                                        disabled
                                                                    >
                                                                        {radioOptionArray.map((option) => (
                                                                            <FormControlLabel
                                                                                key={option.value}
                                                                                value={option.value}
                                                                                control={<Radio sx={radioColorSx} />}
                                                                                label={option.label}
                                                                            />
                                                                        ))}
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={3}></Grid>
                                                        </Grid>

                                                        {/* ------------------------PRIMARY ACCOUNT -------------------------------- */}
                                                        <Grid container className='p-4'>

                                                            {(addTransferDetails[transferIndex].non_register_account_type.length > 0) || (addTransferDetails[transferIndex].register_account_type.length > 0) &&
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <label className='label-text'>Primary's Account</label>
                                                                </Grid>
                                                            }


                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {(addTransferDetails[transferIndex].register_account_type.length > 0) &&
                                                                    <label className='font15px margin-top10px'>Non-Registered Account</label>
                                                                }
                                                            </Grid>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {(addTransferDetails[transferIndex].register_account_type.length > 0) &&
                                                                    <label className='font15px margin-top10px'>Registered Account</label>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {addTransferDetails[transferIndex].non_register_account_type.length > 0 && (
                                                                    <FormControl>
                                                                        {addTransferDetails[transferIndex].non_register_account_type.map((item, index) => (
                                                                            <div className="d-flex" key={`${item.value}_${index}`}>
                                                                                <input
                                                                                    className="asset_checkbox-1 font16px"
                                                                                    id={`non_reg_type${item.value}_${index}_${transferIndex}`}
                                                                                    type="checkbox"
                                                                                    disabled
                                                                                    checked={item.account_checked}

                                                                                />
                                                                                <label
                                                                                    htmlFor={`non_reg_type${item.value}_${index}_${transferIndex}`}
                                                                                    className='review-label-account-type'
                                                                                >
                                                                                    {item.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </FormControl>
                                                                )}
                                                            </Grid>


                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {addTransferDetails[transferIndex].register_account_type.length > 0 && (
                                                                    <FormControl>
                                                                        {addTransferDetails[transferIndex].register_account_type.map((item, index) => (
                                                                            <div className="d-flex" key={`reg-${item.id}-${index}`}>
                                                                                <input
                                                                                    className="asset_checkbox-1 font16px"
                                                                                    id={`p_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                                    type="checkbox"
                                                                                    disabled
                                                                                    checked={item.account_checked}

                                                                                />
                                                                                <label
                                                                                    htmlFor={`p_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                                    className='review-label-account-type'
                                                                                >
                                                                                    {item.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </FormControl>
                                                                )}

                                                            </Grid>
                                                        </Grid>

                                                        <Divider className='divider' />

                                                        {/* ------------------------SPOUSAL ACCOUNT -------------------------------- */}
                                                        <Grid container className='p-4'>
                                                            {(addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0) || (addTransferDetails[transferIndex].spouse_register_account_type.length > 0) &&
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <label className='label-text'>Spouse's Account</label>
                                                                </Grid>
                                                            }

                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {(addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0) &&
                                                                    <label className='font15px margin-top10px'>Non-Registered Account</label>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {(addTransferDetails[transferIndex].spouse_register_account_type.length > 0) &&
                                                                    <label className='font15px margin-top10px'>Registered Account</label>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {addTransferDetails[transferIndex].spouse_non_register_account_type.length > 0 && (
                                                                    <FormControl>
                                                                        {addTransferDetails[transferIndex].spouse_non_register_account_type.map((item, index) => (
                                                                            <div className="d-flex" key={`${item.value}_${index}`}>
                                                                                <input
                                                                                    className="asset_checkbox-1 font16px"
                                                                                    id={`spouse_non_register_account_type_${item.value}_${index}_${transferIndex}`}
                                                                                    type="checkbox"
                                                                                    disabled
                                                                                    checked={item.account_checked}

                                                                                />
                                                                                <label
                                                                                    htmlFor={`spouse_non_register_account_type_${item.value}_${index}_${transferIndex}`}
                                                                                    className='review-label-account-type'
                                                                                >
                                                                                    {item.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </FormControl>
                                                                )}
                                                            </Grid>

                                                            <Grid item xs={6} sm={6} md={6}>
                                                                {addTransferDetails[transferIndex].spouse_register_account_type.length > 0 && (
                                                                    <FormControl>
                                                                        {addTransferDetails[transferIndex].spouse_register_account_type.map((item, index) => (
                                                                            <div className="d-flex" key={`s_reg-${item.id}-${index}`}>
                                                                                <input
                                                                                    className="asset_checkbox-1 font16px"
                                                                                    id={`s_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                                    type="checkbox"
                                                                                    disabled
                                                                                    checked={item.account_checked}

                                                                                />
                                                                                <label
                                                                                    htmlFor={`s_reg_account_type${item.value}_${index}_${transferIndex}`}
                                                                                    className='review-label-account-type'
                                                                                >
                                                                                    {item.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </FormControl>
                                                                )}

                                                            </Grid>
                                                        </Grid>

                                                        <Grid container spacing={2} className='p-4'>
                                                            <Grid item xs={12} className='align-content-center text-left'>
                                                                <label htmlFor="irrevocable-beneficiary" className='font15px bold-text'>Delivering Institution Information</label>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Street No"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='street_number'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.street_number}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Street Name"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='street_name'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.street_name}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Street Type"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='street_type'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.street_type}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="City"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='city'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.city}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <FormControl fullWidth size="small">
                                                                    <InputLabel id="select-tpi-province">Province</InputLabel>
                                                                    <Select
                                                                        labelId="select-tpi-province"
                                                                        label="Province"
                                                                        value={item.province}
                                                                        name='province'
                                                                        MenuProps={{
                                                                            disableScrollLock: true,
                                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                                        }}
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    >
                                                                        {provinceList.map((option) => (
                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                {option.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <FormControl fullWidth size="small">
                                                                    <InputLabel id="select-l-country">Country</InputLabel>
                                                                    <Select
                                                                        labelId="select-l-country"
                                                                        label="Country"
                                                                        value={item.country}
                                                                        name='country'
                                                                        MenuProps={{
                                                                            disableScrollLock: true,
                                                                            PaperProps: { sx: { maxHeight: 200 } }
                                                                        }}
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    >
                                                                        {countryList.map((option) => (
                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                {option.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Postal Code"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='postal_code'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.postal_code}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Business Phone"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='business_phone'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.business_phone}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Extension"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='extension'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.extension}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Institution Contact"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='institution_contact'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.institution_contact}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <TextField
                                                                    label="Dealer Number"
                                                                    fullWidth
                                                                    size="small"
                                                                    name='dealer_number'
                                                                    // onChange={(e) => handleTransferChange(e, transferIndex)}
                                                                    value={item.dealer_number}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}></Grid>

                                                            {item.transfer_instructions.map((instruction, instructionIndex) => (
                                                                <div className='beneficiary-box m-3 width100' key={instructionIndex}>
                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        justifyContent="space-between"
                                                                        alignItems="center"
                                                                        className='form-head-gray-title'
                                                                    >
                                                                        <Grid item>
                                                                            <Typography component='h3'>Transfer Instruction #{instructionIndex + 1}</Typography>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid container spacing={2} className='p-3'>
                                                                        <Grid item xs={6}>
                                                                            <FormControl fullWidth size="small">
                                                                                <InputLabel id="select-tpi-instruction_currency">Currency</InputLabel>
                                                                                <Select
                                                                                    labelId="select-tpi-instruction_currency"
                                                                                    label="Currency"
                                                                                    name='instruction_currency'
                                                                                    value={instruction.instruction_currency || ''}
                                                                                    MenuProps={{
                                                                                        disableScrollLock: true,
                                                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                                                    }}
                                                                                // onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                                                >
                                                                                    {currencyArray.map((option) => (
                                                                                        <MenuItem key={option.value} value={option.value}>
                                                                                            {option.label}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        <Grid item xs={6}>
                                                                            <TextField
                                                                                label="Institution Account Number"
                                                                                fullWidth
                                                                                size="small"
                                                                                name='institution_account_number'
                                                                                // onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                                                value={instruction.institution_account_number}
                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                            <Typography component='h3' className='text-capitalize bold-text'>Receiving Institution Account</Typography>
                                                                        </Grid>

                                                                        {/* <Grid item xs={3}>
                                            <Typography component='h3'> {getCurrencyLabel(accountTypeData.account_currency)} - {getAccountTypeLabel(accountTypeData.account_type)}</Typography>
                                        </Grid> */}
                                                                        <Grid item xs={6}></Grid>

                                                                        <Grid item xs={6}>
                                                                            <FormControl fullWidth size="small">
                                                                                <InputLabel id="select-tpi-institution_transfer_type">Transfer Type</InputLabel>
                                                                                <Select
                                                                                    labelId="select-tpi-institution_transfer_type"
                                                                                    label="Transfer Type"
                                                                                    name='institution_transfer_type'
                                                                                    value={instruction.institution_transfer_type || ''}
                                                                                    MenuProps={{
                                                                                        disableScrollLock: true,
                                                                                        PaperProps: { sx: { maxHeight: 200 } }
                                                                                    }}
                                                                                // onChange={(e) => handleTransferInstructionChange(e, transferIndex, instructionIndex)}
                                                                                >
                                                                                    {institutionTransferType.map((option) => (
                                                                                        <MenuItem key={option.value} value={option.value}>
                                                                                            {option.label}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={6}>
                                                                            <Grid
                                                                                container
                                                                                direction="row"
                                                                                justifyContent="start"
                                                                                alignItems="center"
                                                                            >
                                                                                <Grid item className='margin-right10px text-wrap'>
                                                                                    {instruction.ti_file && (
                                                                                        <Typography variant="body2">
                                                                                            {instruction.ti_file.name ? instruction.ti_file.name : instruction.ti_file}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Grid>
                                                                                {/* <Grid item className='margin-right10px'>
                                                                                    {instruction.ti_file && (
                                                                                        <>
                                                                                            // ADD DOWNLOADFILE FUNCTION
                                                                                            <IconButton sx={{ p: "0 10px 0 0" }} onClick={() => downloadFile(item.id, instruction.id, instruction.ti_file)}>
                                                                                                <CloudDownload sx={{ color: '#2598c4' }} />
                                                                                            </IconButton>
                                                                                        </>
                                                                                    )}
                                                                                </Grid> */}


                                                                            </Grid>
                                                                        </Grid>

                                                                        {/* <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                            <Grid item xs={5} sm={5} md={5}>
                                                <label className='font15px margin-top10px font-weight500px'>Please upload the statement for any accounts you wish to transfer to us.</label>
                                            </Grid>
                                        </Grid> */}

                                                                        <Grid item xs={12} sm={12} md={12}>
                                                                            <Box
                                                                                sx={{
                                                                                    // height: 400,
                                                                                    marginTop: 1,
                                                                                    width: 1,
                                                                                    '& .odd': {
                                                                                        bgcolor: '#f5f5f5'
                                                                                    },
                                                                                    '& .even': {
                                                                                        bgcolor: '#eee'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <div className="file-card min-height-100px">
                                                                                    <ul className="file-list width100" >

                                                                                        {instruction?.user_account_file?.length ? (
                                                                                            instruction.user_account_file.map((file) => {

                                                                                                return (
                                                                                                    <li key={file.id} className="file-item">

                                                                                                        <FormControlLabel
                                                                                                            control={
                                                                                                                <Checkbox
                                                                                                                    sx={checkboxColorSx}
                                                                                                                    checked={file.selected}
                                                                                                                    aria-label={`Select file ${file.file_name}`}
                                                                                                                />
                                                                                                            }
                                                                                                        // label="Select"
                                                                                                        />
                                                                                                        <p className='mb-0'>{file.file_name}</p>
                                                                                                        <FontAwesomeIcon
                                                                                                            className="padding6px margin-left10px cursor-pointer"
                                                                                                            icon={faDownload}
                                                                                                            title="Download file"
                                                                                                        />
                                                                                                    </li>
                                                                                                );
                                                                                            })
                                                                                        ) : (
                                                                                            <p>No files available.</p>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            </Box>
                                                                        </Grid>

                                                                    </Grid>
                                                                </div>
                                                            ))}
                                                        </Grid>
                                                    </div>
                                                ))}

                                            </Grid>
                                        </Box>
                                    </Paper>


                                    {/* ----------------- TRANSFER DETAILS ---------------- */}




                                    {/* ======================= BANKING INFORMATION=============== */}

                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Banking Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>

                                                {accountRow.bank_details.length > 0 ? accountRow?.bank_details?.map((bankRow, bIndex) => (
                                                    <React.Fragment key={bIndex}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Name of bank: </span>
                                                                <span className="bold-text">{bankRow.bank_name}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Currency: </span>
                                                                <span className="bold-text">{getCurrencyLabel(bankRow.bank_currency)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Transit Number: </span>
                                                                <span className="bold-text">{bankRow.bank_transit_number}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Institution Number: </span>
                                                                <span className="bold-text">{bankRow.bank_institution_number}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Account Number: </span>
                                                                <span className="bold-text">{bankRow.bank_account_number}</span>
                                                            </Typography>
                                                        </Grid>
                                                    </React.Fragment>
                                                )) :
                                                    <Grid item xs={12}>
                                                        <Typography component="h2" variant="h4" gutterBottom className='font13px black-text-1 text-capitalize text-center'>
                                                            No record found
                                                        </Typography>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Box>
                                    </Paper>


                                    {/* ----------------------EFT INFORMATION ------------------- */}
                                    <Paper elevation={3} className='mt-3 review-box-shadow' xs={12}>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Eft Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>

                                                {accountRow.eft_details.length > 0 ? accountRow.eft_details?.map((eftRow, bIndex) => (
                                                    <React.Fragment key={bIndex}>
                                                        <Grid item xs={12} sm={6}>

                                                            {/* TODO:: */}
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Existing Investment Account: </span>
                                                                <span className="bold-text">{eftRow.eft_investment_account}</span>
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Name of bank: </span>
                                                                <span className="bold-text">{eftRow.bank_name}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Transit Number: </span>
                                                                <span className="bold-text">{eftRow.bank_transit_number}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Institution Number: </span>
                                                                <span className="bold-text">{eftRow.bank_institution_number}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Account Number: </span>
                                                                <span className="bold-text">{eftRow.bank_account_number}</span>
                                                            </Typography>
                                                        </Grid>
                                                    </React.Fragment>
                                                )) :
                                                    <Grid item xs={12}>
                                                        <Typography component="h2" variant="h4" gutterBottom className='black-text-1 font13px text-capitalize text-center'>
                                                            No record found
                                                        </Typography>
                                                    </Grid>
                                                }

                                            </Grid>
                                        </Box>
                                    </Paper>


                                    {/* ----------------------------PAC INFORMATION ------------------------------ */}

                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        Pac Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>
                                                {accountRow?.pac_information.length > 0 ? accountRow?.pac_information?.map((pacInfoRow, pacIndex) => (
                                                    <React.Fragment key={pacIndex}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Frequency: </span>
                                                                <span className="bold-text">{getPacFrequencyLabel(pacInfoRow.pac_frequency)}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Start Date: </span>
                                                                <span className="bold-text">{pacInfoRow.pac_start_date || '-'}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Account Option: </span>
                                                                <span className="bold-text">{getAccountOptionLabel(pacInfoRow.pac_account_option)}</span>
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Account Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.pac_account_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Name: </span>
                                                                <span className="bold-text">{pacInfoRow.pac_bank_name || '-'}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Transit Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.pac_transit_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Institution Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.pac_institution_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="bold-text">Plan Instruction:</span>
                                                            </Typography>
                                                        </Grid>

                                                        {pacInfoRow.plan_instruction?.map((piiRow, pIndex) => (
                                                            <React.Fragment key={pIndex}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Contribute Type: </span>
                                                                        <span className="bold-text">{getContributionTypeLabel(piiRow.pii_contribution_type)}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Number: </span>
                                                                        <span className="bold-text">{piiRow.pii_fund_number}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Name: </span>
                                                                        <span className="bold-text">{piiRow.pii_fund_name}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Gross Amount: </span>
                                                                        <span className="bold-text">{numberFormat(piiRow.pii_gross_amount)}</span>
                                                                    </Typography>
                                                                </Grid>
                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                )) :
                                                    <Grid item xs={12}>
                                                        <Typography component="h2" variant="h4" gutterBottom className='black-text-1 font13px text-capitalize text-center'>
                                                            No record found
                                                        </Typography>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Box>
                                    </Paper>

                                    {/* ----------------------SWP INFORMATION --------------------- */}
                                    <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "#3f51b5"
                                                    }}
                                                        className='text-capitalize'>
                                                        SWP Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>

                                                {accountRow?.swp_information.length > 0 ? accountRow?.swp_information?.map((pacInfoRow, pacIndex) => (
                                                    <React.Fragment key={pacIndex}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Frequency: </span>
                                                                <span className="bold-text">{getPacFrequencyLabel(pacInfoRow.swp_frequency)}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Start Date: </span>
                                                                <span className="bold-text">{pacInfoRow.swp_start_date || '-'}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text"> Account Option: </span>
                                                                <span className="bold-text">{getAccountOptionLabel(pacInfoRow.swp_account_option)}</span>
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Account Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.swp_account_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Name: </span>
                                                                <span className="bold-text">{pacInfoRow.swp_bank_name || '-'}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Transit Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.swp_transit_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Institution Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.swp_institution_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="bold-text">Plan Instruction:</span>
                                                            </Typography>
                                                        </Grid>

                                                        {pacInfoRow.plan_instruction?.map((piiRow, pIndex) => (
                                                            <React.Fragment key={pIndex}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Contribute Type: </span>
                                                                        <span className="bold-text">{getContributionTypeLabel(piiRow.swp_pii_contribution_type)}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Number: </span>
                                                                        <span className="bold-text">{piiRow.swp_pii_fund_number}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Name: </span>
                                                                        <span className="bold-text">{piiRow.swp_pii_fund_name}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Gross Amount: </span>
                                                                        <span className="bold-text">{numberFormat(piiRow.swp_pii_gross_amount)}</span>
                                                                    </Typography>
                                                                </Grid>
                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                )) : <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom className='black-text-1 font13px text-capitalize text-center'>
                                                        No record found
                                                    </Typography>
                                                </Grid>
                                                }
                                            </Grid>
                                        </Box>
                                    </Paper>


                                    {/* ----------------------------INCOME SWEEP ---------------------- */}
                                    {/* <Paper elevation={3} className='mt-3 review-box-shadow'>
                                        <Box p={3}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Typography component="h2" variant="h4" gutterBottom sx={{
    fontWeight: "bold",
    fontSize: "15px",
    color: "#3f51b5"
  }}
 className='text-capitalize'>
                                                        Income Sweep Information
                                                    </Typography>
                                                    <Divider />
                                                </Grid>
                                                {accountRow?.income_sweep_information.length > 0 ? accountRow.income_sweep_information.map((pacInfoRow, pacIndex) => (
                                                    <React.Fragment key={pacIndex}>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Frequency: </span>
                                                                <span className="bold-text">{getPacFrequencyLabel(pacInfoRow.income_sweep_frequency)}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Start Date: </span>
                                                                <span className="bold-text">{pacInfoRow.income_sweep_start_date || '-'}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">PAC Account Option: </span>
                                                                <span className="bold-text">{getAccountOptionLabel(pacInfoRow.income_sweep_account_option)}</span>
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Account Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.income_sweep_account_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Bank Name: </span>
                                                                <span className="bold-text">{pacInfoRow.income_sweep_bank_name || '-'}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Transit Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.income_sweep_transit_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={6}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="light-text">Institution Number: </span>
                                                                <span className="bold-text">{(pacInfoRow.income_sweep_institution_number)}</span>
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12}>
                                                            <Typography component="h2" className="primary-account-holder">
                                                                <span className="bold-text">Plan Instruction:</span>
                                                            </Typography>
                                                        </Grid>

                                                        {pacInfoRow.plan_instruction?.map((piiRow, pIndex) => (
                                                            <React.Fragment key={pIndex}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Contribute Type: </span>
                                                                        <span className="bold-text">{getContributionTypeLabel(piiRow.income_sweep_pii_contribution_type)}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Number: </span>
                                                                        <span className="bold-text">{piiRow.income_sweep_pii_fund_number}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Fund Name: </span>
                                                                        <span className="bold-text">{piiRow.income_sweep_pii_fund_name}</span>
                                                                    </Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <Typography component="h2" className="primary-account-holder">
                                                                        <span className="light-text">Gross Amount: </span>
                                                                        <span className="bold-text">{numberFormat(piiRow.income_sweep_pii_gross_amount)}</span>
                                                                    </Typography>
                                                                </Grid>
                                                            </React.Fragment>
                                                        ))}
                                                    </React.Fragment>
                                                )) :
                                                    <Grid item xs={12}>
                                                        <Typography component="h2" variant="h4" gutterBottom  className='black-text-1 font13px text-capitalize text-center'>
                                                            No record found
                                                        </Typography>
                                                    </Grid>}
                                            </Grid>
                                        </Box>
                                    </Paper> */}
                                    <Divider />
                                </Grid>
                            </React.Fragment>
                        );
                    })}
                </Grid>
            }
        </>
    );
};


const questionnaireComponent = (loadData, questionnaireData, questionnairePortfolioData) => {

    // console.log(questionnairePortfolioData)

    return loadData &&
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={12}>
                <>
                    <Paper elevation={3} className='review-box-shadow'>
                        <Box p={3}>
                            <Grid className="card-body" /* sx={{ padding: '15px 15px 15px 20px !important' }} */>
                                <Grid item xs={12}>
                                    <FormControl>
                                        {questionnaireData.map((question, index) => {
                                            return (
                                                <Grid item xs={12} key={question.id}>
                                                    <FormLabel
                                                        id={`demo-controlled-radio-buttons-group${question.id}`}
                                                        className='black-text-1 font14px margin-top15px'
                                                    >
                                                        {index + 1}. {question.question}
                                                    </FormLabel>

                                                    <RadioGroup
                                                        aria-labelledby={`questionnaire-controlled-radio-buttons-group_${question.id}`}
                                                        value={question.selected_answers}
                                                        name={`kyc_questions_${question.id}`}
                                                        disabled
                                                    >
                                                        {question.options.map((option) => (
                                                            <FormControlLabel
                                                                className='margin-left20px'
                                                                key={option.id}
                                                                value={option.id} // Convert to string for Yup validation
                                                                control={<Radio sx={checkboxColorSx} />}
                                                                label={option.option}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                </Grid>
                                            )
                                        }
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>


                            {/*--------------- portfolio details ------------ */}

                            {questionnairePortfolioData.map((portfolioData, portfolioIndex) => {

                                return (
                                    <>
                                        <Grid key={portfolioIndex} className="card-body mt-3" /* sx={{ padding: '15px 15px 15px 20px !important' }} */>
                                            <Grid item xs={12} sx={{ border: '1px #e9edf0 solid' }} >
                                                <Grid spacing={2} className='mt-3 container' key={portfolioIndex + 1}>

                                                    <Grid item xs={12}>
                                                        <Grid className="form-head-gray-title">
                                                            <label className="label-text font14px">
                                                                {portfolioData.full_name} : Account ({portfolioData.account_holder})
                                                            </label>

                                                            <label className="label-text font14px">
                                                                : {' '}{portfolioData.account_type_label} - {portfolioData.account_type}
                                                            </label>
                                                        </Grid>
                                                    </Grid>
                                                    {/* intended use of account data */}

                                                    <Grid item xs={12} sx={{ marginRight: 2, padding: '15px' }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                            What are the intended use of the accounts?
                                                        </Typography>

                                                        <List dense>
                                                            {useOfAccountArray
                                                                .filter(option => portfolioData.intended_use_account.includes(option.value))
                                                                .map(option => (
                                                                    <ListItem key={option.value} sx={{ pl: 0 }}>
                                                                        <ListItemIcon sx={{ minWidth: '30px' }}>
                                                                            <CheckIcon fontSize="small" color="primary" />
                                                                        </ListItemIcon>
                                                                        <Typography variant="body2">{option.label}</Typography>
                                                                    </ListItem>
                                                                ))}
                                                        </List>
                                                    </Grid>

                                                    {/* Data Row */}
                                                    <Grid item xs={12} className='mb-2'>

                                                        <Grid container className="p-1 mt-2" sx={{ border: '1px #e9edf0 solid' }}>

                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>

                                                                <Grid item xs={12} md={7}>
                                                                    <Grid container spacing={2} sx={{ p: 2, flexDirection: "column" }}>
                                                                        {/* Recommended Risk Category */}
                                                                        <Grid item xs={12} sx={{ display: "flex" }}>
                                                                            <span className="font14px margin-right8px">
                                                                                Recommended Risk Category:
                                                                            </span>
                                                                            <span className="font14px font-weight-600" >
                                                                                {portfolioData.account_recommended_portfolio}
                                                                            </span>
                                                                        </Grid>

                                                                        {/* Advisor's Risk Category */}
                                                                        <Grid item xs={12} sx={{ display: "flex" }}>
                                                                            <span className="font14px margin-right8px">
                                                                                Advisor's Risk Category:
                                                                            </span>
                                                                            <span className="font14px font-weight-600" >
                                                                                {portfolioData.advisor_risk_category}
                                                                            </span>
                                                                        </Grid>

                                                                        {/* All Portfolios */}
                                                                        <Grid item xs={12} sx={{ display: "flex" }}>
                                                                            <span className="font14px margin-right8px">
                                                                                All Portfolios:
                                                                            </span>
                                                                            <span className="font14px font-weight-600" >
                                                                                {portfolioData.all_portfolio}
                                                                            </span>
                                                                        </Grid>

                                                                        {/* Selected Enhanced Portfolio */}
                                                                        <Grid item xs={12} sx={{ display: "flex" }}>
                                                                            <span className="font14px margin-right8px">
                                                                                Selected Enhanced Portfolio:
                                                                            </span>
                                                                            <span className="font14px font-weight-600" >
                                                                                {portfolioData.account_selected_portfolio}
                                                                            </span>
                                                                        </Grid>


                                                                        {/* Notes */}
                                                                        <Grid item xs={12}>
                                                                            <Divider sx={{ my: 2 }} />

                                                                            <span className="font14px font-weight-600">Notes :</span>
                                                                            <div className="font14px mt-2">
                                                                                {" "}{portfolioData.account_portfolio_note}
                                                                            </div>
                                                                            {/* <InputBase
                                                                                className="textarea-mui"
                                                                                name="sup_changes_income"
                                                                                id="sup_changes_income"
                                                                                value={portfolioData.account_portfolio_note}
                                                                                placeholder="Notes"
                                                                                multiline
                                                                                minRows={3}
                                                                                maxRows={5}
                                                                                fullWidth
                                                                                readOnly
                                                                            /> */}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>


                                                                <Grid item xs={12} md={5}>
                                                                    <Grid container spacing={2} sx={{ padding: '10px', flexDirection: 'column' }}>

                                                                        <Grid item xs={12}>
                                                                            <>
                                                                                <Paper>
                                                                                    {/* todo:: need to add no data found */}
                                                                                    <Typography variant="h4" component="h2" sx={{ marginTop: 2 }}>
                                                                                        Public :

                                                                                        {(portfolioData?.enhancement_portfolio_details?.public.length > 0) ?
                                                                                            "" :
                                                                                            <span className="font14px margin-left8px font-weight300">
                                                                                                N/A
                                                                                            </span>

                                                                                        }
                                                                                    </Typography>

                                                                                    {
                                                                                        portfolioData?.enhancement_portfolio_details?.public?.map((portfolio) => (
                                                                                            <Grid container spacing={2} key={portfolio.id} sx={{ padding: '5px' }}>

                                                                                                <Grid item xs={12}>
                                                                                                    <span className="font14px margin-right8px">
                                                                                                        {portfolio.name} :
                                                                                                    </span>
                                                                                                    <span className="font14px font-weight-600">
                                                                                                        {portfolio.allocation || '0.00%'}
                                                                                                    </span>
                                                                                                </Grid>
                                                                                            </Grid >
                                                                                        ))
                                                                                    }

                                                                                    {/* Private Portfolios Section */}
                                                                                    <Typography variant="h4" component="h2" sx={{ marginTop: 2 }}>
                                                                                        Private :
                                                                                        {(portfolioData?.enhancement_portfolio_details?.private.length > 0) ?
                                                                                            "" :
                                                                                            <span className="font14px margin-left8px font-weight300">
                                                                                                N/A
                                                                                            </span>
                                                                                        }
                                                                                    </Typography>

                                                                                    {portfolioData?.enhancement_portfolio_details?.private?.map((portfolio) => (
                                                                                        <Grid container spacing={2} key={portfolio.id} sx={{ padding: '5px' }}>
                                                                                            <Grid item xs={12}>
                                                                                                <span className="font14px margin-right8px">
                                                                                                    {portfolio.name} :
                                                                                                </span>
                                                                                                <span className="font14px font-weight-600">
                                                                                                    {portfolio.allocation || '0.00%'}
                                                                                                </span>
                                                                                            </Grid>
                                                                                        </Grid >

                                                                                    ))}

                                                                                </Paper>
                                                                            </>
                                                                        </Grid>

                                                                    </Grid>
                                                                </Grid>

                                                            </Box>
                                                        </Grid>
                                                    </Grid>


                                                    {/* ------------- graph -------------------- */}

                                                    {(portfolioData?.modified_portfolio !== 1) &&
                                                        <>
                                                            <Grid item container spacing={1} xs={12} className='mt-2' >
                                                                <Grid item xs={12} sm={6}>
                                                                    <DonutChart
                                                                        seriesValue={portfolioData.chartData?.chartValue}
                                                                        labelTitle={portfolioData.chartData?.chartTitle}
                                                                        total={0}
                                                                        centerTitle={portfolioData.portfolio_name}
                                                                        dataFormat="percentage"
                                                                    />
                                                                </Grid>

                                                                {/*<Grid item xs={12} sm={6} sx={{ padding: '16px' }}>
                                                                    {portfolioData?.category
                                                                        // .filter(cat => cat.assets.length > 0)
                                                                        .map((row) => (
                                                                            <div className='chart-asset-category' key={row.id}>
                                                                                <h6>{row.category}</h6>
                                                                                <ul>
                                                                                    {row.assets
                                                                                        // .filter(asset => asset.value > 0) // only show assets with value > 0
                                                                                        .map(asset => (
                                                                                            <li key={asset.id} className='padding5px'>
                                                                                                <span>
                                                                                                    {asset.title} : {asset.value}%
                                                                                                </span>
                                                                                            </li>
                                                                                        ))}
                                                                                </ul>
                                                                            </div>
                                                                        ))}
                                                                </Grid>*/}

                                                                <Grid item xs={12} sm={6} sx={{ padding: '16px' }} key={portfolioIndex}>
                                                                    {portfolioData?.category.map((row) => (
                                                                        <div className="chart-asset-category" key={row.id}>
                                                                            <h6>
                                                                                {Array.isArray(row.category)
                                                                                    ? row.category.map(cat => cat.name).join(', ')
                                                                                    : row.category}
                                                                            </h6>

                                                                            <ul>
                                                                                {row.assets.map(asset => (
                                                                                    <li key={asset.id} className="padding5px">
                                                                                        <span>
                                                                                            {asset.title} : {asset.value}%
                                                                                        </span>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    }


                                                </Grid >
                                            </Grid>
                                        </Grid>

                                    </>
                                )
                            })}

                        </Box>
                    </Paper>
                </>
            </Grid >
        </Grid >
}